export const HOAI2021 = {
  year: 2021,
  correspondingDin: 2008,
  rateOptions: [
    {
      label: 'Base honorarium rate',
      value: 0,
    },
    {
      label: 'Quarter rate',
      value: 25,
    },
    {
      label: 'Middle rate',
      value: 50,
    },
    {
      label: 'Three quarter rate',
      value: 75,
    },
    {
      label: 'Upper honorarium rate',
      value: 100,
    },
  ],
  data: [
    {
      label: '§ 35 Abs. 1 Gebäude',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      shownCostGroups: ['200', '300', '400', '600'],
      disabledCostGroups: ['200', '600', 'bausubstanz'],
      additionalFields: [
        {
          label: 'Mitzuverarbeitende Bausubstanz nach §4 Abs. 3',
          key: 'bausubstanz',
        },
      ],
      creditableCostFunction: function creditableCostFunction(
        entries,
        additionalFields
      ) {
        const costGroups = entries.reduce((acc, el) => {
          if (el.number != '400') {
            acc += el.costs ?? 0;
          }
          return acc;
        }, 0);

        const other =
          costGroups +
          additionalFields?.reduce((acc, el) => {
            acc += el.costs ?? 0;
            return acc;
          }, 0);

        const technicalCosts =
          entries.find((el) => el.number == '400')?.costs ?? 0;

        if (technicalCosts < 0.25 * other) {
          return other + technicalCosts;
        } else {
          return other + 0.25 * other + (technicalCosts - 0.25 * other) * 0.5;
        }
      },
      honorariumZone: {
        I: {
          25000: {
            min: 3120,
            max: 3657,
          },
          35000: {
            min: 4217,
            max: 4942,
          },
          50000: {
            min: 5804,
            max: 6801,
          },
          75000: {
            min: 8342,
            max: 9776,
          },
          100000: {
            min: 10790,
            max: 12644,
          },
          150000: {
            min: 15500,
            max: 18164,
          },
          200000: {
            min: 20037,
            max: 23480,
          },
          300000: {
            min: 28750,
            max: 33692,
          },
          500000: {
            min: 45232,
            max: 53006,
          },
          750000: {
            min: 64666,
            max: 75781,
          },
          1000000: {
            min: 83182,
            max: 97479,
          },
          1500000: {
            min: 119307,
            max: 139813,
          },
          2000000: {
            min: 153965,
            max: 180428,
          },
          3000000: {
            min: 220161,
            max: 258002,
          },
          5000000: {
            min: 343879,
            max: 402984,
          },
          7500000: {
            min: 493923,
            max: 578816,
          },
          10000000: {
            min: 638277,
            max: 747981,
          },
          15000000: {
            min: 915129,
            max: 1072416,
          },
          20000000: {
            min: 1180414,
            max: 1383298,
          },
          25000000: {
            min: 1436874,
            max: 1683837,
          },
        },
        II: {
          25000: {
            min: 3657,
            max: 4339,
          },
          35000: {
            min: 4942,
            max: 5865,
          },
          50000: {
            min: 6801,
            max: 8071,
          },
          75000: {
            min: 9776,
            max: 11601,
          },
          100000: {
            min: 12644,
            max: 15005,
          },
          150000: {
            min: 18164,
            max: 21555,
          },
          200000: {
            min: 23480,
            max: 27863,
          },
          300000: {
            min: 33692,
            max: 39981,
          },
          500000: {
            min: 53006,
            max: 62900,
          },
          750000: {
            min: 75781,
            max: 89927,
          },
          1000000: {
            min: 97479,
            max: 115675,
          },
          1500000: {
            min: 139813,
            max: 165911,
          },
          2000000: {
            min: 180428,
            max: 214108,
          },
          3000000: {
            min: 258002,
            max: 306162,
          },
          5000000: {
            min: 402984,
            max: 478207,
          },
          7500000: {
            min: 578816,
            max: 686862,
          },
          10000000: {
            min: 747981,
            max: 887604,
          },
          15000000: {
            min: 1072416,
            max: 1272601,
          },
          20000000: {
            min: 1383298,
            max: 1641513,
          },
          25000000: {
            min: 1683837,
            max: 1998153,
          },
        },
        III: {
          25000: {
            min: 4339,
            max: 5412,
          },
          35000: {
            min: 5865,
            max: 7315,
          },
          50000: {
            min: 8071,
            max: 10066,
          },
          75000: {
            min: 11601,
            max: 14469,
          },
          100000: {
            min: 15005,
            max: 18713,
          },
          150000: {
            min: 21555,
            max: 26883,
          },
          200000: {
            min: 27863,
            max: 34751,
          },
          300000: {
            min: 39981,
            max: 49864,
          },
          500000: {
            min: 62900,
            max: 78449,
          },
          750000: {
            min: 89927,
            max: 112156,
          },
          1000000: {
            min: 115675,
            max: 144268,
          },
          1500000: {
            min: 165911,
            max: 206923,
          },
          2000000: {
            min: 214108,
            max: 267034,
          },
          3000000: {
            min: 306162,
            max: 381843,
          },
          5000000: {
            min: 478207,
            max: 596416,
          },
          7500000: {
            min: 686862,
            max: 856648,
          },
          10000000: {
            min: 887604,
            max: 1107012,
          },
          15000000: {
            min: 1272601,
            max: 1587176,
          },
          20000000: {
            min: 1641513,
            max: 2047281,
          },
          25000000: {
            min: 1998153,
            max: 2492079,
          },
        },
        IV: {
          25000: {
            min: 5412,
            max: 6094,
          },
          35000: {
            min: 7315,
            max: 8237,
          },
          50000: {
            min: 10066,
            max: 11336,
          },
          75000: {
            min: 14469,
            max: 16293,
          },
          100000: {
            min: 18713,
            max: 21074,
          },
          150000: {
            min: 26883,
            max: 30274,
          },
          200000: {
            min: 34751,
            max: 39134,
          },
          300000: {
            min: 49864,
            max: 56153,
          },
          500000: {
            min: 78449,
            max: 88343,
          },
          750000: {
            min: 112156,
            max: 126301,
          },
          1000000: {
            min: 144268,
            max: 162464,
          },
          1500000: {
            min: 206923,
            max: 233022,
          },
          2000000: {
            min: 267034,
            max: 300714,
          },
          3000000: {
            min: 381843,
            max: 430003,
          },
          5000000: {
            min: 596416,
            max: 671640,
          },
          7500000: {
            min: 856648,
            max: 964694,
          },
          10000000: {
            min: 1107012,
            max: 1246635,
          },
          15000000: {
            min: 1587176,
            max: 1787360,
          },
          20000000: {
            min: 2047281,
            max: 2305496,
          },
          25000000: {
            min: 2492079,
            max: 2806395,
          },
        },
        V: {
          25000: {
            min: 6094,
            max: 6631,
          },
          35000: {
            min: 8237,
            max: 8962,
          },
          50000: {
            min: 11336,
            max: 12333,
          },
          75000: {
            min: 16293,
            max: 17727,
          },
          100000: {
            min: 21074,
            max: 22928,
          },
          150000: {
            min: 30274,
            max: 32938,
          },
          200000: {
            min: 39134,
            max: 42578,
          },
          300000: {
            min: 56153,
            max: 61095,
          },
          500000: {
            min: 88343,
            max: 96118,
          },
          750000: {
            min: 126301,
            max: 137416,
          },
          1000000: {
            min: 162464,
            max: 176761,
          },
          1500000: {
            min: 233022,
            max: 253527,
          },
          2000000: {
            min: 300714,
            max: 327177,
          },
          3000000: {
            min: 430003,
            max: 467843,
          },
          5000000: {
            min: 671640,
            max: 730744,
          },
          7500000: {
            min: 964694,
            max: 1049587,
          },
          10000000: {
            min: 1246635,
            max: 1356339,
          },
          15000000: {
            min: 1787360,
            max: 1944648,
          },
          20000000: {
            min: 2305496,
            max: 2508380,
          },
          25000000: {
            min: 2806395,
            max: 3053358,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '2',
          siemon: [
            {
              title:
                'a) Klären der Aufgabenstellung auf Grundlage der Vorgaben oder der Bedarfsplanung des Auftraggebers',
              maxPercent: '0.75',
            },
            {
              title: 'b) Ortsbesichtigung',
              maxPercent: '0.10',
            },
            {
              title:
                'c) Beraten zum gesamten Leistungs- und Untersuchungsbedarf',
              maxPercent: '0.75',
            },
            {
              title:
                'd) Formulieren der Entscheidungshilfen für die Auswahl anderer an der Planung fachlich Beteiligter ',
              maxPercent: '0.25',
            },
            {
              title:
                'e) Zusammenfassen, Erläutern und Dokumentieren der Ergebnisse ',
              maxPercent: '0.15',
            },
          ],
        },
        {
          title: 'Vorplanung',
          maxPercent: '7',
        },
        {
          title: 'Entwurfsplanung',
          maxPercent: '15',
        },
        {
          title: 'Genehmigungsplanung',
          maxPercent: '3',
        },
        {
          title: 'Ausführungsplanung',
          maxPercent: '25',
        },
        {
          title: 'Vorbereitung der Vergabe',
          maxPercent: '10',
        },
        {
          title: 'Mitwirkung bei der Vergabe',
          maxPercent: '4',
        },
        {
          title: 'Objektüberwachung – Bauüberwachung und Dokumentation',
          maxPercent: '32',
        },
        {
          title: 'Objektbetreuung',
          maxPercent: '2',
        },
      ],
    },
    {
      label: '§ 35 Abs. 1 Innenräume',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      shownCostGroups: ['200', '300', '400', '600'],
      disabledCostGroups: ['200', '600', 'bausubstanz'],
      additionalFields: [
        {
          label: 'Mitzuverarbeitende Bausubstanz nach §4 Abs. 3',
          key: 'bausubstanz',
        },
      ],
      creditableCostFunction: function creditableCostFunction(
        entries,
        additionalFields
      ) {
        const costGroups = entries.reduce((acc, el) => {
          if (el.number != '400') {
            acc += el.costs ?? 0;
          }
          return acc;
        }, 0);

        const other =
          costGroups +
          additionalFields?.reduce((acc, el) => {
            acc += el.costs ?? 0;
            return acc;
          }, 0);

        const technicalCosts =
          entries.find((el) => el.number == '400')?.costs ?? 0;

        if (technicalCosts < 0.25 * other) {
          return other + technicalCosts;
        } else {
          return other + 0.25 * other + (technicalCosts - 0.25 * other) * 0.5;
        }
      },
      honorariumZone: {
        I: {
          25000: {
            min: 3120,
            max: 3657,
          },
          35000: {
            min: 4217,
            max: 4942,
          },
          50000: {
            min: 5804,
            max: 6801,
          },
          75000: {
            min: 8342,
            max: 9776,
          },
          100000: {
            min: 10790,
            max: 12644,
          },
          150000: {
            min: 15500,
            max: 18164,
          },
          200000: {
            min: 20037,
            max: 23480,
          },
          300000: {
            min: 28750,
            max: 33692,
          },
          500000: {
            min: 45232,
            max: 53006,
          },
          750000: {
            min: 64666,
            max: 75781,
          },
          1000000: {
            min: 83182,
            max: 97479,
          },
          1500000: {
            min: 119307,
            max: 139813,
          },
          2000000: {
            min: 153965,
            max: 180428,
          },
          3000000: {
            min: 220161,
            max: 258002,
          },
          5000000: {
            min: 343879,
            max: 402984,
          },
          7500000: {
            min: 493923,
            max: 578816,
          },
          10000000: {
            min: 638277,
            max: 747981,
          },
          15000000: {
            min: 915129,
            max: 1072416,
          },
          20000000: {
            min: 1180414,
            max: 1383298,
          },
          25000000: {
            min: 1436874,
            max: 1683837,
          },
        },
        II: {
          25000: {
            min: 3657,
            max: 4339,
          },
          35000: {
            min: 4942,
            max: 5865,
          },
          50000: {
            min: 6801,
            max: 8071,
          },
          75000: {
            min: 9776,
            max: 11601,
          },
          100000: {
            min: 12644,
            max: 15005,
          },
          150000: {
            min: 18164,
            max: 21555,
          },
          200000: {
            min: 23480,
            max: 27863,
          },
          300000: {
            min: 33692,
            max: 39981,
          },
          500000: {
            min: 53006,
            max: 62900,
          },
          750000: {
            min: 75781,
            max: 89927,
          },
          1000000: {
            min: 97479,
            max: 115675,
          },
          1500000: {
            min: 139813,
            max: 165911,
          },
          2000000: {
            min: 180428,
            max: 214108,
          },
          3000000: {
            min: 258002,
            max: 306162,
          },
          5000000: {
            min: 402984,
            max: 478207,
          },
          7500000: {
            min: 578816,
            max: 686862,
          },
          10000000: {
            min: 747981,
            max: 887604,
          },
          15000000: {
            min: 1072416,
            max: 1272601,
          },
          20000000: {
            min: 1383298,
            max: 1641513,
          },
          25000000: {
            min: 1683837,
            max: 1998153,
          },
        },
        III: {
          25000: {
            min: 4339,
            max: 5412,
          },
          35000: {
            min: 5865,
            max: 7315,
          },
          50000: {
            min: 8071,
            max: 10066,
          },
          75000: {
            min: 11601,
            max: 14469,
          },
          100000: {
            min: 15005,
            max: 18713,
          },
          150000: {
            min: 21555,
            max: 26883,
          },
          200000: {
            min: 27863,
            max: 34751,
          },
          300000: {
            min: 39981,
            max: 49864,
          },
          500000: {
            min: 62900,
            max: 78449,
          },
          750000: {
            min: 89927,
            max: 112156,
          },
          1000000: {
            min: 115675,
            max: 144268,
          },
          1500000: {
            min: 165911,
            max: 206923,
          },
          2000000: {
            min: 214108,
            max: 267034,
          },
          3000000: {
            min: 306162,
            max: 381843,
          },
          5000000: {
            min: 478207,
            max: 596416,
          },
          7500000: {
            min: 686862,
            max: 856648,
          },
          10000000: {
            min: 887604,
            max: 1107012,
          },
          15000000: {
            min: 1272601,
            max: 1587176,
          },
          20000000: {
            min: 1641513,
            max: 2047281,
          },
          25000000: {
            min: 1998153,
            max: 2492079,
          },
        },
        IV: {
          25000: {
            min: 5412,
            max: 6094,
          },
          35000: {
            min: 7315,
            max: 8237,
          },
          50000: {
            min: 10066,
            max: 11336,
          },
          75000: {
            min: 14469,
            max: 16293,
          },
          100000: {
            min: 18713,
            max: 21074,
          },
          150000: {
            min: 26883,
            max: 30274,
          },
          200000: {
            min: 34751,
            max: 39134,
          },
          300000: {
            min: 49864,
            max: 56153,
          },
          500000: {
            min: 78449,
            max: 88343,
          },
          750000: {
            min: 112156,
            max: 126301,
          },
          1000000: {
            min: 144268,
            max: 162464,
          },
          1500000: {
            min: 206923,
            max: 233022,
          },
          2000000: {
            min: 267034,
            max: 300714,
          },
          3000000: {
            min: 381843,
            max: 430003,
          },
          5000000: {
            min: 596416,
            max: 671640,
          },
          7500000: {
            min: 856648,
            max: 964694,
          },
          10000000: {
            min: 1107012,
            max: 1246635,
          },
          15000000: {
            min: 1587176,
            max: 1787360,
          },
          20000000: {
            min: 2047281,
            max: 2305496,
          },
          25000000: {
            min: 2492079,
            max: 2806395,
          },
        },
        V: {
          25000: {
            min: 6094,
            max: 6631,
          },
          35000: {
            min: 8237,
            max: 8962,
          },
          50000: {
            min: 11336,
            max: 12333,
          },
          75000: {
            min: 16293,
            max: 17727,
          },
          100000: {
            min: 21074,
            max: 22928,
          },
          150000: {
            min: 30274,
            max: 32938,
          },
          200000: {
            min: 39134,
            max: 42578,
          },
          300000: {
            min: 56153,
            max: 61095,
          },
          500000: {
            min: 88343,
            max: 96118,
          },
          750000: {
            min: 126301,
            max: 137416,
          },
          1000000: {
            min: 162464,
            max: 176761,
          },
          1500000: {
            min: 233022,
            max: 253527,
          },
          2000000: {
            min: 300714,
            max: 327177,
          },
          3000000: {
            min: 430003,
            max: 467843,
          },
          5000000: {
            min: 671640,
            max: 730744,
          },
          7500000: {
            min: 964694,
            max: 1049587,
          },
          10000000: {
            min: 1246635,
            max: 1356339,
          },
          15000000: {
            min: 1787360,
            max: 1944648,
          },
          20000000: {
            min: 2305496,
            max: 2508380,
          },
          25000000: {
            min: 2806395,
            max: 3053358,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '2',
        },
        {
          title: 'Vorplanung',
          maxPercent: '7',
        },
        {
          title: 'Entwurfsplanung',
          maxPercent: '15',
        },
        {
          title: 'Genehmigungsplanung',
          maxPercent: '2',
        },
        {
          title: 'Ausführungsplanung',
          maxPercent: '30',
        },
        {
          title: 'Vorbereitung der Vergabe',
          maxPercent: '7',
        },
        {
          title: 'Mitwirkung bei der Vergabe',
          maxPercent: '3',
        },
        {
          title: 'Objektüberwachung – Bauüberwachung und Dokumentation',
          maxPercent: '32',
        },
        {
          title: 'Objektbetreuung',
          maxPercent: '2',
        },
      ],
    },
    {
      label: '§ 20 Abs. 1 Flächennutzungsplan',
      unitLabel: 'Fläche in ha',
      unit: 'ha',
      honorariumZone: {
        I: {
          1000: {
            min: 70439,
            max: 85269,
          },
          1250: {
            min: 78957,
            max: 95579,
          },
          1500: {
            min: 86492,
            max: 104700,
          },
          1750: {
            min: 93260,
            max: 112894,
          },
          2000: {
            min: 99407,
            max: 120334,
          },
          2500: {
            min: 111311,
            max: 134745,
          },
          3000: {
            min: 121868,
            max: 147525,
          },
          3500: {
            min: 131387,
            max: 159047,
          },
          4000: {
            min: 140069,
            max: 169557,
          },
          5000: {
            min: 155461,
            max: 188190,
          },
          6000: {
            min: 168813,
            max: 204352,
          },
          7000: {
            min: 180589,
            max: 218607,
          },
          8000: {
            min: 191097,
            max: 231328,
          },
          9000: {
            min: 200556,
            max: 242779,
          },
          10000: {
            min: 209126,
            max: 253153,
          },
          11000: {
            min: 216893,
            max: 262555,
          },
          12000: {
            min: 223912,
            max: 271052,
          },
          13000: {
            min: 230331,
            max: 278822,
          },
          14000: {
            min: 236214,
            max: 285944,
          },
          15000: {
            min: 241614,
            max: 292480,
          },
        },
        II: {
          1000: {
            min: 85269,
            max: 100098,
          },
          1250: {
            min: 95579,
            max: 112202,
          },
          1500: {
            min: 104700,
            max: 122909,
          },
          1750: {
            min: 112894,
            max: 132527,
          },
          2000: {
            min: 120334,
            max: 141262,
          },
          2500: {
            min: 134745,
            max: 158178,
          },
          3000: {
            min: 147525,
            max: 173181,
          },
          3500: {
            min: 159047,
            max: 186707,
          },
          4000: {
            min: 169557,
            max: 199045,
          },
          5000: {
            min: 188190,
            max: 220918,
          },
          6000: {
            min: 204352,
            max: 239892,
          },
          7000: {
            min: 218607,
            max: 256626,
          },
          8000: {
            min: 231328,
            max: 271559,
          },
          9000: {
            min: 242779,
            max: 285001,
          },
          10000: {
            min: 253153,
            max: 297179,
          },
          11000: {
            min: 262555,
            max: 308217,
          },
          12000: {
            min: 271052,
            max: 318191,
          },
          13000: {
            min: 278822,
            max: 327313,
          },
          14000: {
            min: 285944,
            max: 335673,
          },
          15000: {
            min: 292480,
            max: 343346,
          },
        },
        III: {
          1000: {
            min: 100098,
            max: 114927,
          },
          1250: {
            min: 112202,
            max: 128824,
          },
          1500: {
            min: 122909,
            max: 141118,
          },
          1750: {
            min: 132527,
            max: 152161,
          },
          2000: {
            min: 141262,
            max: 162190,
          },
          2500: {
            min: 158178,
            max: 181612,
          },
          3000: {
            min: 173181,
            max: 198838,
          },
          3500: {
            min: 186707,
            max: 214367,
          },
          4000: {
            min: 199045,
            max: 228533,
          },
          5000: {
            min: 220918,
            max: 253647,
          },
          6000: {
            min: 239892,
            max: 275431,
          },
          7000: {
            min: 256626,
            max: 294645,
          },
          8000: {
            min: 271559,
            max: 311790,
          },
          9000: {
            min: 285001,
            max: 327224,
          },
          10000: {
            min: 297179,
            max: 341206,
          },
          11000: {
            min: 308217,
            max: 353878,
          },
          12000: {
            min: 318191,
            max: 365331,
          },
          13000: {
            min: 327313,
            max: 375804,
          },
          14000: {
            min: 335673,
            max: 385402,
          },
          15000: {
            min: 343346,
            max: 394213,
          },
        },
      },
      phases: [
        {
          title: 'Vorentwurf für die frühzeitigen Beteiligungen',
          maxPercent: '60',
        },
        {
          title: 'Entwurf zur öffentlichen Auslegung',
          maxPercent: '30',
        },
        {
          title: 'Plan zur Beschlussfassung',
          maxPercent: '10',
        },
      ],
    },
    {
      label: '§ 21 Abs. 1 Bebauungsplan',
      unitLabel: 'Fläche in ha',
      unit: 'ha',
      honorariumZone: {
        I: {
          0.5: {
            min: 5000,
            max: 5335,
          },
          1: {
            min: 5000,
            max: 8799,
          },
          2: {
            min: 7699,
            max: 14502,
          },
          3: {
            min: 10306,
            max: 19413,
          },
          4: {
            min: 12669,
            max: 23866,
          },
          5: {
            min: 14864,
            max: 28000,
          },
          6: {
            min: 16931,
            max: 31893,
          },
          7: {
            min: 18896,
            max: 35595,
          },
          8: {
            min: 20776,
            max: 39137,
          },
          9: {
            min: 22584,
            max: 42542,
          },
          10: {
            min: 24330,
            max: 45830,
          },
          15: {
            min: 32325,
            max: 60892,
          },
          20: {
            min: 39427,
            max: 74270,
          },
          25: {
            min: 46385,
            max: 87376,
          },
          30: {
            min: 52975,
            max: 99791,
          },
          40: {
            min: 65342,
            max: 123086,
          },
          50: {
            min: 76901,
            max: 144860,
          },
          60: {
            min: 87599,
            max: 165012,
          },
          80: {
            min: 107471,
            max: 202445,
          },
          100: {
            min: 125791,
            max: 236955,
          },
        },
        II: {
          0.5: {
            min: 5335,
            max: 7838,
          },
          1: {
            min: 8799,
            max: 12926,
          },
          2: {
            min: 14502,
            max: 21305,
          },
          3: {
            min: 19413,
            max: 28521,
          },
          4: {
            min: 23866,
            max: 35062,
          },
          5: {
            min: 28000,
            max: 41135,
          },
          6: {
            min: 31893,
            max: 46856,
          },
          7: {
            min: 35595,
            max: 52294,
          },
          8: {
            min: 39137,
            max: 57497,
          },
          9: {
            min: 42542,
            max: 62501,
          },
          10: {
            min: 45830,
            max: 67331,
          },
          15: {
            min: 60892,
            max: 89458,
          },
          20: {
            min: 74270,
            max: 109113,
          },
          25: {
            min: 87376,
            max: 128366,
          },
          30: {
            min: 99791,
            max: 146606,
          },
          40: {
            min: 123086,
            max: 180830,
          },
          50: {
            min: 144860,
            max: 212819,
          },
          60: {
            min: 165012,
            max: 242425,
          },
          80: {
            min: 202445,
            max: 297419,
          },
          100: {
            min: 236955,
            max: 348119,
          },
        },
        III: {
          0.5: {
            min: 7838,
            max: 10341,
          },
          1: {
            min: 12926,
            max: 17054,
          },
          2: {
            min: 21305,
            max: 28109,
          },
          3: {
            min: 28521,
            max: 37628,
          },
          4: {
            min: 35062,
            max: 46258,
          },
          5: {
            min: 41135,
            max: 54271,
          },
          6: {
            min: 46856,
            max: 61818,
          },
          7: {
            min: 52294,
            max: 68992,
          },
          8: {
            min: 57497,
            max: 75857,
          },
          9: {
            min: 62501,
            max: 82459,
          },
          10: {
            min: 67331,
            max: 88831,
          },
          15: {
            min: 89458,
            max: 118025,
          },
          20: {
            min: 109113,
            max: 143956,
          },
          25: {
            min: 128366,
            max: 169357,
          },
          30: {
            min: 146606,
            max: 193422,
          },
          40: {
            min: 180830,
            max: 238574,
          },
          50: {
            min: 212819,
            max: 280778,
          },
          60: {
            min: 242425,
            max: 319838,
          },
          80: {
            min: 297419,
            max: 392393,
          },
          100: {
            min: 348119,
            max: 459282,
          },
        },
      },
      phases: [
        {
          title: 'Vorentwurf für die frühzeitigen Beteiligungen',
          maxPercent: '60',
        },
        {
          title: 'Entwurf zur öffentlichen Auslegung',
          maxPercent: '30',
        },
        {
          title: 'Plan zur Beschlussfassung',
          maxPercent: '10',
        },
      ],
    },
    {
      label: '§ 28 Abs. 1 Landschaftsplan',
      unitLabel: 'Fläche in ha',
      unit: 'ha',
      honorariumZone: {
        I: {
          1000: {
            min: 23403,
            max: 27963,
          },
          1250: {
            min: 26560,
            max: 31735,
          },
          1500: {
            min: 29445,
            max: 35182,
          },
          1750: {
            min: 32119,
            max: 38375,
          },
          2000: {
            min: 34620,
            max: 41364,
          },
          2500: {
            min: 39212,
            max: 46851,
          },
          3000: {
            min: 43374,
            max: 51824,
          },
          3500: {
            min: 47199,
            max: 56393,
          },
          4000: {
            min: 50747,
            max: 60633,
          },
          5000: {
            min: 57180,
            max: 68319,
          },
          6000: {
            min: 63562,
            max: 75944,
          },
          7000: {
            min: 69505,
            max: 83045,
          },
          8000: {
            min: 75095,
            max: 89724,
          },
          9000: {
            min: 80394,
            max: 96055,
          },
          10000: {
            min: 85445,
            max: 102090,
          },
          11000: {
            min: 89986,
            max: 107516,
          },
          12000: {
            min: 94309,
            max: 112681,
          },
          13000: {
            min: 98438,
            max: 117615,
          },
          14000: {
            min: 102392,
            max: 122339,
          },
          15000: {
            min: 106187,
            max: 126873,
          },
        },
        II: {
          1000: {
            min: 27963,
            max: 32826,
          },
          1250: {
            min: 31735,
            max: 37254,
          },
          1500: {
            min: 35182,
            max: 41300,
          },
          1750: {
            min: 38375,
            max: 45049,
          },
          2000: {
            min: 41364,
            max: 48558,
          },
          2500: {
            min: 46851,
            max: 54999,
          },
          3000: {
            min: 51824,
            max: 60837,
          },
          3500: {
            min: 56393,
            max: 66201,
          },
          4000: {
            min: 60633,
            max: 71178,
          },
          5000: {
            min: 68319,
            max: 80200,
          },
          6000: {
            min: 75944,
            max: 89151,
          },
          7000: {
            min: 83045,
            max: 97487,
          },
          8000: {
            min: 89724,
            max: 105329,
          },
          9000: {
            min: 96055,
            max: 112761,
          },
          10000: {
            min: 102090,
            max: 119845,
          },
          11000: {
            min: 107516,
            max: 126214,
          },
          12000: {
            min: 112681,
            max: 132278,
          },
          13000: {
            min: 117615,
            max: 138069,
          },
          14000: {
            min: 122339,
            max: 143615,
          },
          15000: {
            min: 126873,
            max: 148938,
          },
        },
        III: {
          1000: {
            min: 32826,
            max: 37385,
          },
          1250: {
            min: 37254,
            max: 42428,
          },
          1500: {
            min: 41300,
            max: 47036,
          },
          1750: {
            min: 45049,
            max: 51306,
          },
          2000: {
            min: 48558,
            max: 55302,
          },
          2500: {
            min: 54999,
            max: 62638,
          },
          3000: {
            min: 60837,
            max: 69286,
          },
          3500: {
            min: 66201,
            max: 75396,
          },
          4000: {
            min: 71178,
            max: 81064,
          },
          5000: {
            min: 80200,
            max: 91339,
          },
          6000: {
            min: 89151,
            max: 101533,
          },
          7000: {
            min: 97487,
            max: 111027,
          },
          8000: {
            min: 105329,
            max: 119958,
          },
          9000: {
            min: 112761,
            max: 128422,
          },
          10000: {
            min: 119845,
            max: 136490,
          },
          11000: {
            min: 126214,
            max: 143744,
          },
          12000: {
            min: 132278,
            max: 150650,
          },
          13000: {
            min: 138069,
            max: 157246,
          },
          14000: {
            min: 143615,
            max: 163562,
          },
          15000: {
            min: 148938,
            max: 169623,
          },
        },
      },
      phases: [
        {
          title: 'Zusammenstellen der Ausgangsbedingungen',
          maxPercent: '3',
        },
        {
          title: 'Ermitteln der Planungsgrundlagen',
          maxPercent: '37',
        },
        {
          title: 'Vorläufige Fassung',
          maxPercent: '50',
        },
        {
          title: 'Abgestimmte Fassung',
          maxPercent: '10',
        },
      ],
    },
    {
      label: '§ 29 Abs. 1 Grünordnungsplan',
      unitLabel: 'Fläche in ha',
      unit: 'ha',
      honorariumZone: {
        I: {
          1.5: {
            min: 5219,
            max: 6067,
          },
          2: {
            min: 6008,
            max: 6985,
          },
          3: {
            min: 7450,
            max: 8661,
          },
          4: {
            min: 8770,
            max: 10195,
          },
          5: {
            min: 10006,
            max: 11632,
          },
          10: {
            min: 15445,
            max: 17955,
          },
          15: {
            min: 20183,
            max: 23462,
          },
          20: {
            min: 24513,
            max: 28496,
          },
          25: {
            min: 28560,
            max: 33201,
          },
          30: {
            min: 32394,
            max: 37658,
          },
          40: {
            min: 39580,
            max: 46011,
          },
          50: {
            min: 46282,
            max: 53803,
          },
          75: {
            min: 61579,
            max: 71586,
          },
          100: {
            min: 75430,
            max: 87687,
          },
          125: {
            min: 88255,
            max: 102597,
          },
          150: {
            min: 100288,
            max: 116585,
          },
          175: {
            min: 111675,
            max: 129822,
          },
          200: {
            min: 122516,
            max: 142425,
          },
          225: {
            min: 133555,
            max: 155258,
          },
          250: {
            min: 144284,
            max: 167730,
          },
        },
        II: {
          1.5: {
            min: 6067,
            max: 6980,
          },
          2: {
            min: 6985,
            max: 8036,
          },
          3: {
            min: 8661,
            max: 9965,
          },
          4: {
            min: 10195,
            max: 11730,
          },
          5: {
            min: 11632,
            max: 13383,
          },
          10: {
            min: 17955,
            max: 20658,
          },
          15: {
            min: 23462,
            max: 26994,
          },
          20: {
            min: 28496,
            max: 32785,
          },
          25: {
            min: 33201,
            max: 38199,
          },
          30: {
            min: 37658,
            max: 43326,
          },
          40: {
            min: 46011,
            max: 52938,
          },
          50: {
            min: 53803,
            max: 61902,
          },
          75: {
            min: 71586,
            max: 82362,
          },
          100: {
            min: 87687,
            max: 100887,
          },
          125: {
            min: 102597,
            max: 118042,
          },
          150: {
            min: 116585,
            max: 134136,
          },
          175: {
            min: 129822,
            max: 149366,
          },
          200: {
            min: 142425,
            max: 163866,
          },
          225: {
            min: 155258,
            max: 178630,
          },
          250: {
            min: 167730,
            max: 192980,
          },
        },
        III: {
          1.5: {
            min: 6980,
            max: 7828,
          },
          2: {
            min: 8036,
            max: 9013,
          },
          3: {
            min: 9965,
            max: 11175,
          },
          4: {
            min: 11730,
            max: 13155,
          },
          5: {
            min: 13383,
            max: 15009,
          },
          10: {
            min: 20658,
            max: 23167,
          },
          15: {
            min: 26994,
            max: 30274,
          },
          20: {
            min: 32785,
            max: 36769,
          },
          25: {
            min: 38199,
            max: 42840,
          },
          30: {
            min: 43326,
            max: 48590,
          },
          40: {
            min: 52938,
            max: 59370,
          },
          50: {
            min: 61902,
            max: 69423,
          },
          75: {
            min: 82362,
            max: 92369,
          },
          100: {
            min: 100887,
            max: 113145,
          },
          125: {
            min: 118042,
            max: 132383,
          },
          150: {
            min: 134136,
            max: 150433,
          },
          175: {
            min: 149366,
            max: 167513,
          },
          200: {
            min: 163866,
            max: 183774,
          },
          225: {
            min: 178630,
            max: 200333,
          },
          250: {
            min: 192980,
            max: 216426,
          },
        },
      },
      phases: [
        {
          title: 'Zusammenstellen der Ausgangsbedingungen',
          maxPercent: '3',
        },
        {
          title: 'Ermitteln der Planungsgrundlagen',
          maxPercent: '37',
        },
        {
          title: 'Vorläufige Fassung',
          maxPercent: '50',
        },
        {
          title: 'Abgestimmte Fassung',
          maxPercent: '10',
        },
      ],
    },
    {
      label: '§ 30 Abs. 1 - Landschaftsrahmenplan',
      unitLabel: 'Fläche in ha',
      unit: 'ha',
      honorariumZone: {
        I: {
          5000: {
            min: 61880,
            max: 71935,
          },
          6000: {
            min: 67933,
            max: 78973,
          },
          7000: {
            min: 73473,
            max: 85413,
          },
          8000: {
            min: 78600,
            max: 91373,
          },
          9000: {
            min: 83385,
            max: 96936,
          },
          10000: {
            min: 87880,
            max: 102161,
          },
          12000: {
            min: 96149,
            max: 111773,
          },
          14000: {
            min: 103631,
            max: 120471,
          },
          16000: {
            min: 110477,
            max: 128430,
          },
          18000: {
            min: 116791,
            max: 135769,
          },
          20000: {
            min: 122649,
            max: 142580,
          },
          25000: {
            min: 138047,
            max: 160480,
          },
          30000: {
            min: 152052,
            max: 176761,
          },
          40000: {
            min: 177097,
            max: 205875,
          },
          50000: {
            min: 199330,
            max: 231721,
          },
          60000: {
            min: 219553,
            max: 255230,
          },
          70000: {
            min: 238243,
            max: 276958,
          },
          80000: {
            min: 253946,
            max: 295212,
          },
          90000: {
            min: 268420,
            max: 312038,
          },
          100000: {
            min: 281843,
            max: 327643,
          },
        },
        II: {
          5000: {
            min: 71935,
            max: 82764,
          },
          6000: {
            min: 78973,
            max: 90861,
          },
          7000: {
            min: 85413,
            max: 98270,
          },
          8000: {
            min: 91373,
            max: 105128,
          },
          9000: {
            min: 96936,
            max: 111528,
          },
          10000: {
            min: 102161,
            max: 117540,
          },
          12000: {
            min: 111773,
            max: 128599,
          },
          14000: {
            min: 120471,
            max: 138607,
          },
          16000: {
            min: 128430,
            max: 147763,
          },
          18000: {
            min: 135769,
            max: 156208,
          },
          20000: {
            min: 142580,
            max: 164043,
          },
          25000: {
            min: 160480,
            max: 184638,
          },
          30000: {
            min: 176761,
            max: 203370,
          },
          40000: {
            min: 205875,
            max: 236867,
          },
          50000: {
            min: 231721,
            max: 266604,
          },
          60000: {
            min: 255230,
            max: 293652,
          },
          70000: {
            min: 276958,
            max: 318650,
          },
          80000: {
            min: 295212,
            max: 339652,
          },
          90000: {
            min: 312038,
            max: 359011,
          },
          100000: {
            min: 327643,
            max: 376965,
          },
        },
        III: {
          5000: {
            min: 82764,
            max: 92820,
          },
          6000: {
            min: 90861,
            max: 101900,
          },
          7000: {
            min: 98270,
            max: 110210,
          },
          8000: {
            min: 105128,
            max: 117901,
          },
          9000: {
            min: 111528,
            max: 125078,
          },
          10000: {
            min: 117540,
            max: 131820,
          },
          12000: {
            min: 128599,
            max: 144223,
          },
          14000: {
            min: 138607,
            max: 155447,
          },
          16000: {
            min: 147763,
            max: 165716,
          },
          18000: {
            min: 156208,
            max: 175186,
          },
          20000: {
            min: 164043,
            max: 183974,
          },
          25000: {
            min: 184638,
            max: 207070,
          },
          30000: {
            min: 203370,
            max: 228078,
          },
          40000: {
            min: 236867,
            max: 265645,
          },
          50000: {
            min: 266604,
            max: 298995,
          },
          60000: {
            min: 293652,
            max: 329329,
          },
          70000: {
            min: 318650,
            max: 357365,
          },
          80000: {
            min: 339652,
            max: 380918,
          },
          90000: {
            min: 359011,
            max: 402630,
          },
          100000: {
            min: 376965,
            max: 422765,
          },
        },
      },
      phases: [
        {
          title: 'Zusammenstellen der Ausgangsbedingungen',
          maxPercent: '3',
        },
        {
          title: 'Ermitteln der Planungsgrundlagen',
          maxPercent: '37',
        },
        {
          title: 'Vorläufige Fassung',
          maxPercent: '50',
        },
        {
          title: 'Abgestimmte Fassung',
          maxPercent: '10',
        },
      ],
    },
    {
      label: '§ 31 Abs. 1 Landschaftspflegerischer Begleitplan',
      unitLabel: 'Fläche in ha',
      unit: 'ha',
      honorariumZone: {
        I: {
          6: {
            min: 5324,
            max: 6189,
          },
          8: {
            min: 6130,
            max: 7126,
          },
          12: {
            min: 7600,
            max: 8836,
          },
          16: {
            min: 8947,
            max: 10401,
          },
          20: {
            min: 10207,
            max: 11866,
          },
          40: {
            min: 15755,
            max: 18315,
          },
          100: {
            min: 29126,
            max: 33859,
          },
          200: {
            min: 47180,
            max: 54846,
          },
          300: {
            min: 62748,
            max: 72944,
          },
          400: {
            min: 76829,
            max: 89314,
          },
          500: {
            min: 89855,
            max: 104456,
          },
          600: {
            min: 102062,
            max: 118647,
          },
          700: {
            min: 113602,
            max: 132062,
          },
          800: {
            min: 124575,
            max: 144819,
          },
          1200: {
            min: 167729,
            max: 194985,
          },
          1600: {
            min: 207279,
            max: 240961,
          },
          2000: {
            min: 244349,
            max: 284056,
          },
          2400: {
            min: 279559,
            max: 324987,
          },
          3200: {
            min: 343814,
            max: 399683,
          },
          4000: {
            min: 400847,
            max: 465985,
          },
        },
        II: {
          6: {
            min: 6189,
            max: 7121,
          },
          8: {
            min: 7126,
            max: 8199,
          },
          12: {
            min: 8836,
            max: 10166,
          },
          16: {
            min: 10401,
            max: 11966,
          },
          20: {
            min: 11866,
            max: 13652,
          },
          40: {
            min: 18315,
            max: 21072,
          },
          100: {
            min: 33859,
            max: 38956,
          },
          200: {
            min: 54846,
            max: 63103,
          },
          300: {
            min: 72944,
            max: 83925,
          },
          400: {
            min: 89314,
            max: 102759,
          },
          500: {
            min: 104456,
            max: 120181,
          },
          600: {
            min: 118647,
            max: 136508,
          },
          700: {
            min: 132062,
            max: 151942,
          },
          800: {
            min: 144819,
            max: 166620,
          },
          1200: {
            min: 194985,
            max: 224338,
          },
          1600: {
            min: 240961,
            max: 277235,
          },
          2000: {
            min: 284056,
            max: 326817,
          },
          2400: {
            min: 324987,
            max: 373910,
          },
          3200: {
            min: 399683,
            max: 459851,
          },
          4000: {
            min: 465985,
            max: 536133,
          },
        },
        III: {
          6: {
            min: 7121,
            max: 7986,
          },
          8: {
            min: 8199,
            max: 9195,
          },
          12: {
            min: 10166,
            max: 11401,
          },
          16: {
            min: 11966,
            max: 13420,
          },
          20: {
            min: 13652,
            max: 15311,
          },
          40: {
            min: 21072,
            max: 23632,
          },
          100: {
            min: 38956,
            max: 43689,
          },
          200: {
            min: 63103,
            max: 70769,
          },
          300: {
            min: 83925,
            max: 94121,
          },
          400: {
            min: 102759,
            max: 115244,
          },
          500: {
            min: 120181,
            max: 134782,
          },
          600: {
            min: 136508,
            max: 153093,
          },
          700: {
            min: 151942,
            max: 170402,
          },
          800: {
            min: 166620,
            max: 186863,
          },
          1200: {
            min: 224338,
            max: 251594,
          },
          1600: {
            min: 277235,
            max: 310918,
          },
          2000: {
            min: 326817,
            max: 366524,
          },
          2400: {
            min: 373910,
            max: 419338,
          },
          3200: {
            min: 459851,
            max: 515720,
          },
          4000: {
            min: 536133,
            max: 601270,
          },
        },
      },
      phases: [
        {
          title: 'Zusammenstellen der Ausgangsbedingungen',
          maxPercent: '3',
        },
        {
          title: 'Ermitteln der Planungsgrundlagen',
          maxPercent: '37',
        },
        {
          title: 'Vorläufige Fassung',
          maxPercent: '50',
        },
        {
          title: 'Abgestimmte Fassung',
          maxPercent: '10',
        },
      ],
    },
    {
      label: '§ 32 Abs. 1 Pflege- Entwicklungsplan',
      unitLabel: 'Fläche in ha',
      unit: 'ha',
      honorariumZone: {
        I: {
          5: {
            min: 3852,
            max: 7704,
          },
          10: {
            min: 4802,
            max: 9603,
          },
          15: {
            min: 5481,
            max: 10963,
          },
          20: {
            min: 6029,
            max: 12058,
          },
          30: {
            min: 6906,
            max: 13813,
          },
          40: {
            min: 7612,
            max: 15225,
          },
          50: {
            min: 8213,
            max: 16425,
          },
          75: {
            min: 9433,
            max: 18866,
          },
          100: {
            min: 10408,
            max: 20816,
          },
          150: {
            min: 11949,
            max: 23899,
          },
          200: {
            min: 13165,
            max: 26330,
          },
          300: {
            min: 15318,
            max: 30636,
          },
          400: {
            min: 17087,
            max: 34174,
          },
          500: {
            min: 18621,
            max: 37242,
          },
          750: {
            min: 21833,
            max: 43666,
          },
          1000: {
            min: 24507,
            max: 49014,
          },
          1500: {
            min: 28966,
            max: 57932,
          },
          2500: {
            min: 36065,
            max: 72131,
          },
          5000: {
            min: 49288,
            max: 98575,
          },
          10000: {
            min: 69015,
            max: 138029,
          },
        },
        II: {
          5: {
            min: 7704,
            max: 11556,
          },
          10: {
            min: 9603,
            max: 14405,
          },
          15: {
            min: 10963,
            max: 16444,
          },
          20: {
            min: 12058,
            max: 18087,
          },
          30: {
            min: 13813,
            max: 20719,
          },
          40: {
            min: 15225,
            max: 22837,
          },
          50: {
            min: 16425,
            max: 24638,
          },
          75: {
            min: 18866,
            max: 28298,
          },
          100: {
            min: 20816,
            max: 31224,
          },
          150: {
            min: 23899,
            max: 35848,
          },
          200: {
            min: 26330,
            max: 39495,
          },
          300: {
            min: 30636,
            max: 45954,
          },
          400: {
            min: 34174,
            max: 51262,
          },
          500: {
            min: 37242,
            max: 55863,
          },
          750: {
            min: 43666,
            max: 65500,
          },
          1000: {
            min: 49014,
            max: 73522,
          },
          1500: {
            min: 57932,
            max: 86898,
          },
          2500: {
            min: 72131,
            max: 108196,
          },
          5000: {
            min: 98575,
            max: 147863,
          },
          10000: {
            min: 138029,
            max: 207044,
          },
        },
        III: {
          5: {
            min: 11556,
            max: 15408,
          },
          10: {
            min: 14405,
            max: 19207,
          },
          15: {
            min: 16444,
            max: 21925,
          },
          20: {
            min: 18087,
            max: 24116,
          },
          30: {
            min: 20719,
            max: 27626,
          },
          40: {
            min: 22837,
            max: 30450,
          },
          50: {
            min: 24638,
            max: 32851,
          },
          75: {
            min: 28298,
            max: 37731,
          },
          100: {
            min: 31224,
            max: 41633,
          },
          150: {
            min: 35848,
            max: 47798,
          },
          200: {
            min: 39495,
            max: 52660,
          },
          300: {
            min: 45954,
            max: 61272,
          },
          400: {
            min: 51262,
            max: 68349,
          },
          500: {
            min: 55863,
            max: 74484,
          },
          750: {
            min: 65500,
            max: 87333,
          },
          1000: {
            min: 73522,
            max: 98029,
          },
          1500: {
            min: 86898,
            max: 115864,
          },
          2500: {
            min: 108196,
            max: 144261,
          },
          5000: {
            min: 147863,
            max: 197150,
          },
          10000: {
            min: 207044,
            max: 276058,
          },
        },
      },
      phases: [
        {
          title: 'Zusammenstellen der Ausgangsbedingungen',
          maxPercent: '3',
        },
        {
          title: 'Ermitteln der Planungsgrundlagen',
          maxPercent: '37',
        },
        {
          title: 'Vorläufige Fassung',
          maxPercent: '50',
        },
        {
          title: 'Abgestimmte Fassung',
          maxPercent: '10',
        },
      ],
    },
    {
      label: '§ 40 Abs. 1 Freianlagen',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      shownCostGroups: ['500'],
      disabledCostGroups: [
        'gewässer',
        'teiche',
        'erdbau',
        'durchlaesse',
        'laermschutz',
        'stuetzbauwerk',
        'stege',
        'wege',
      ],
      additionalFields: [
        {
          label:
            'Einzelgewässer mit überwiegend ökologischen und landschaftsgestalterischen Elementen nach §38 Abs. 1 Nr. 1',
          key: 'gewässer',
        },
        {
          label: 'Teiche ohne Dämme nach §38 Abs. 1 Nr. 2',
          key: 'teiche',
        },
        {
          label:
            'Flächenhafter Erdbau zur Geländegestaltung nach §38 Abs. 1 Nr. 3',
          key: 'erdbau',
        },
        {
          label:
            'Einfache Durchlässe und Uferbefestigungen als Mittel zur Geländegestaltung nach §38 Abs. 1 Nr. 4',
          key: 'durchlaesse',
        },
        {
          label:
            'Lärmschutzwälle als Mittel zur Geländegestaltung nach §38 Abs. 1 Nr. 5',
          key: 'laermschutz',
        },
        {
          label:
            'Stützbauwerke und Geländeabstützungen ohne Verkehrsbelastung als Mittel zur Geländegestaltung nach §38 Abs. 1 Nr. 6',
          key: 'stuetzbauwerk',
        },
        {
          label: 'Stege und Brücken nach §38 Abs. 1 Nr. 7',
          key: 'stege',
        },
        {
          label:
            'Wege ohne Eignung für den regelmäßigen Fahrverkehr mit einfachen Entwässerungsverhältnissen sowie andere Wege und befestigte Flächen, die als Gestaltungselement der Freianlagen geplant werden nach §38 Abs. 1 Nr. 8',
          key: 'wege',
        },
      ],
      creditableCostFunction: function creditableCostFunction(
        entries,
        additionalFields
      ) {
        const costGroups = entries.reduce((acc, el) => {
          acc += el.costs ?? 0;
          return acc;
        }, 0);

        const other =
          costGroups +
          additionalFields?.reduce((acc, el) => {
            acc += el.costs ?? 0;
            return acc;
          }, 0);

        return other;
      },
      honorariumZone: {
        I: {
          20000: {
            min: 3643,
            max: 4348,
          },
          25000: {
            min: 4406,
            max: 5259,
          },
          30000: {
            min: 5147,
            max: 6143,
          },
          35000: {
            min: 5870,
            max: 7006,
          },
          40000: {
            min: 6577,
            max: 7850,
          },
          50000: {
            min: 7953,
            max: 9492,
          },
          60000: {
            min: 9287,
            max: 11085,
          },
          75000: {
            min: 11227,
            max: 13400,
          },
          100000: {
            min: 14332,
            max: 17106,
          },
          125000: {
            min: 17315,
            max: 20666,
          },
          150000: {
            min: 20201,
            max: 24111,
          },
          200000: {
            min: 25746,
            max: 30729,
          },
          250000: {
            min: 31053,
            max: 37063,
          },
          350000: {
            min: 41147,
            max: 49111,
          },
          500000: {
            min: 55300,
            max: 66004,
          },
          650000: {
            min: 69114,
            max: 82491,
          },
          800000: {
            min: 82430,
            max: 98384,
          },
          1000000: {
            min: 99578,
            max: 118851,
          },
          1250000: {
            min: 120238,
            max: 143510,
          },
          1500000: {
            min: 140204,
            max: 167340,
          },
        },
        II: {
          20000: {
            min: 4348,
            max: 5229,
          },
          25000: {
            min: 5259,
            max: 6325,
          },
          30000: {
            min: 6143,
            max: 7388,
          },
          35000: {
            min: 7006,
            max: 8426,
          },
          40000: {
            min: 7850,
            max: 9441,
          },
          50000: {
            min: 9492,
            max: 11416,
          },
          60000: {
            min: 11085,
            max: 13332,
          },
          75000: {
            min: 13400,
            max: 16116,
          },
          100000: {
            min: 17106,
            max: 20574,
          },
          125000: {
            min: 20666,
            max: 24855,
          },
          150000: {
            min: 24111,
            max: 28998,
          },
          200000: {
            min: 30729,
            max: 36958,
          },
          250000: {
            min: 37063,
            max: 44576,
          },
          350000: {
            min: 49111,
            max: 59066,
          },
          500000: {
            min: 66004,
            max: 79383,
          },
          650000: {
            min: 82491,
            max: 99212,
          },
          800000: {
            min: 98384,
            max: 118326,
          },
          1000000: {
            min: 118851,
            max: 142942,
          },
          1250000: {
            min: 143510,
            max: 172600,
          },
          1500000: {
            min: 167340,
            max: 201261,
          },
        },
        III: {
          20000: {
            min: 5229,
            max: 6521,
          },
          25000: {
            min: 6325,
            max: 7888,
          },
          30000: {
            min: 7388,
            max: 9215,
          },
          35000: {
            min: 8426,
            max: 10508,
          },
          40000: {
            min: 9441,
            max: 11774,
          },
          50000: {
            min: 11416,
            max: 14238,
          },
          60000: {
            min: 13332,
            max: 16627,
          },
          75000: {
            min: 16116,
            max: 20100,
          },
          100000: {
            min: 20574,
            max: 25659,
          },
          125000: {
            min: 24855,
            max: 30999,
          },
          150000: {
            min: 28998,
            max: 36166,
          },
          200000: {
            min: 36958,
            max: 46094,
          },
          250000: {
            min: 44576,
            max: 55594,
          },
          350000: {
            min: 59066,
            max: 73667,
          },
          500000: {
            min: 79383,
            max: 99006,
          },
          650000: {
            min: 99212,
            max: 123736,
          },
          800000: {
            min: 118326,
            max: 147576,
          },
          1000000: {
            min: 142942,
            max: 178276,
          },
          1250000: {
            min: 172600,
            max: 215265,
          },
          1500000: {
            min: 201261,
            max: 251011,
          },
        },
        IV: {
          20000: {
            min: 6521,
            max: 7403,
          },
          25000: {
            min: 7888,
            max: 8954,
          },
          30000: {
            min: 9215,
            max: 10460,
          },
          35000: {
            min: 10508,
            max: 11928,
          },
          40000: {
            min: 11774,
            max: 13365,
          },
          50000: {
            min: 14238,
            max: 16162,
          },
          60000: {
            min: 16627,
            max: 18874,
          },
          75000: {
            min: 20100,
            max: 22816,
          },
          100000: {
            min: 25659,
            max: 29127,
          },
          125000: {
            min: 30999,
            max: 35188,
          },
          150000: {
            min: 36166,
            max: 41053,
          },
          200000: {
            min: 46094,
            max: 52323,
          },
          250000: {
            min: 55594,
            max: 63107,
          },
          350000: {
            min: 73667,
            max: 83622,
          },
          500000: {
            min: 99006,
            max: 112385,
          },
          650000: {
            min: 123736,
            max: 140457,
          },
          800000: {
            min: 147576,
            max: 167518,
          },
          1000000: {
            min: 178276,
            max: 202368,
          },
          1250000: {
            min: 215265,
            max: 244355,
          },
          1500000: {
            min: 251011,
            max: 284931,
          },
        },
        V: {
          20000: {
            min: 7403,
            max: 8108,
          },
          25000: {
            min: 8954,
            max: 9807,
          },
          30000: {
            min: 10460,
            max: 11456,
          },
          35000: {
            min: 11928,
            max: 13064,
          },
          40000: {
            min: 13365,
            max: 14638,
          },
          50000: {
            min: 16162,
            max: 17701,
          },
          60000: {
            min: 18874,
            max: 20672,
          },
          75000: {
            min: 22816,
            max: 24989,
          },
          100000: {
            min: 29127,
            max: 31901,
          },
          125000: {
            min: 35188,
            max: 38539,
          },
          150000: {
            min: 41053,
            max: 44963,
          },
          200000: {
            min: 52323,
            max: 57306,
          },
          250000: {
            min: 63107,
            max: 69117,
          },
          350000: {
            min: 83622,
            max: 91586,
          },
          500000: {
            min: 112385,
            max: 123088,
          },
          650000: {
            min: 140457,
            max: 153834,
          },
          800000: {
            min: 167518,
            max: 183472,
          },
          1000000: {
            min: 202368,
            max: 221641,
          },
          1250000: {
            min: 244355,
            max: 267627,
          },
          1500000: {
            min: 284931,
            max: 312067,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '3',
        },
        {
          title: 'Vorplanung',
          maxPercent: '10',
        },
        {
          title: 'Entwurfsplanung',
          maxPercent: '16',
        },
        {
          title: 'Genehmigungsplanung',
          maxPercent: '4',
        },
        {
          title: 'Ausführungsplanung',
          maxPercent: '25',
        },
        {
          title: 'Vorbereitung der Vergabe',
          maxPercent: '7',
        },
        {
          title: 'Mitwirkung bei der Vergabe',
          maxPercent: '3',
        },
        {
          title: 'Objektüberwachung – Bauüberwachung und Dokumentation',
          maxPercent: '30',
        },
        {
          title: 'Objektbetreuung',
          maxPercent: '2',
        },
      ],
    },
    {
      label: '§ 44 Abs. 1 Ingenieurbauwerke',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      shownCostGroups: ['200', '300', '400', '500'],
      disabledCostGroups: [
        '200',
        '500',
        'maschinentechnik',
        'leitungen',
        'verkehr',
        'ausstattung',
      ],
      additionalFields: [
        {
          label: 'Kosten für die Anlagen der Maschinentechnik nach §42 Abs. 1',
          key: 'maschinentechnik',
        },
        {
          label: 'Umlegen und Verlegen von Leitungen nach §42 Abs. 3',
          key: 'leitungen',
        },
        {
          label:
            'Verkehrsregelnde Maßnahmen während der Bauzeit nach §42 Abs. 3',
          key: 'verkehr',
        },
        {
          label:
            'Ausstattung und Nebenanlagen von Ingenieurbauwerken nach §42 Abs. 3',
          key: 'ausstattung',
        },
      ],
      creditableCostFunction: function creditableCostFunction(
        entries,
        additionalFields
      ) {
        const costGroups = entries.reduce((acc, el) => {
          if (el.number != '400') {
            acc += el.costs ?? 0;
          }
          return acc;
        }, 0);

        const other =
          costGroups +
          additionalFields?.reduce((acc, el) => {
            acc += el.costs ?? 0;
            return acc;
          }, 0);

        const technicalCosts =
          entries.find((el) => el.number == '400')?.costs ?? 0;

        if (technicalCosts < 0.25 * other) {
          return other + technicalCosts;
        } else {
          return other + 0.25 * other + (technicalCosts - 0.25 * other) * 0.5;
        }
      },
      honorariumZone: {
        I: {
          25000: {
            min: 3449,
            max: 4109,
          },
          35000: {
            min: 4475,
            max: 5331,
          },
          50000: {
            min: 5897,
            max: 7024,
          },
          75000: {
            min: 8069,
            max: 9611,
          },
          100000: {
            min: 10079,
            max: 12005,
          },
          150000: {
            min: 13786,
            max: 16422,
          },
          200000: {
            min: 17215,
            max: 20506,
          },
          300000: {
            min: 23534,
            max: 28033,
          },
          500000: {
            min: 34865,
            max: 41530,
          },
          750000: {
            min: 47576,
            max: 56672,
          },
          1000000: {
            min: 59264,
            max: 70594,
          },
          1500000: {
            min: 80998,
            max: 96482,
          },
          2000000: {
            min: 101054,
            max: 120373,
          },
          3000000: {
            min: 137907,
            max: 164272,
          },
          5000000: {
            min: 203584,
            max: 242504,
          },
          7500000: {
            min: 278415,
            max: 331642,
          },
          10000000: {
            min: 347568,
            max: 414014,
          },
          15000000: {
            min: 474901,
            max: 565691,
          },
          20000000: {
            min: 592324,
            max: 705563,
          },
          25000000: {
            min: 702770,
            max: 837123,
          },
        },
        II: {
          25000: {
            min: 4109,
            max: 4768,
          },
          35000: {
            min: 5331,
            max: 6186,
          },
          50000: {
            min: 7024,
            max: 8152,
          },
          75000: {
            min: 9611,
            max: 11154,
          },
          100000: {
            min: 12005,
            max: 13932,
          },
          150000: {
            min: 16422,
            max: 19058,
          },
          200000: {
            min: 20506,
            max: 23797,
          },
          300000: {
            min: 28033,
            max: 32532,
          },
          500000: {
            min: 41530,
            max: 48195,
          },
          750000: {
            min: 56672,
            max: 65767,
          },
          1000000: {
            min: 70594,
            max: 81924,
          },
          1500000: {
            min: 96482,
            max: 111967,
          },
          2000000: {
            min: 120373,
            max: 139692,
          },
          3000000: {
            min: 164272,
            max: 190636,
          },
          5000000: {
            min: 242504,
            max: 281425,
          },
          7500000: {
            min: 331642,
            max: 384868,
          },
          10000000: {
            min: 414014,
            max: 480461,
          },
          15000000: {
            min: 565691,
            max: 656480,
          },
          20000000: {
            min: 705563,
            max: 818801,
          },
          25000000: {
            min: 837123,
            max: 971476,
          },
        },
        III: {
          25000: {
            min: 4768,
            max: 5428,
          },
          35000: {
            min: 6186,
            max: 7042,
          },
          50000: {
            min: 8152,
            max: 9279,
          },
          75000: {
            min: 11154,
            max: 12697,
          },
          100000: {
            min: 13932,
            max: 15859,
          },
          150000: {
            min: 19058,
            max: 21693,
          },
          200000: {
            min: 23797,
            max: 27088,
          },
          300000: {
            min: 32532,
            max: 37031,
          },
          500000: {
            min: 48195,
            max: 54861,
          },
          750000: {
            min: 65767,
            max: 74863,
          },
          1000000: {
            min: 81924,
            max: 93254,
          },
          1500000: {
            min: 111967,
            max: 127452,
          },
          2000000: {
            min: 139692,
            max: 159011,
          },
          3000000: {
            min: 190636,
            max: 217001,
          },
          5000000: {
            min: 281425,
            max: 320345,
          },
          7500000: {
            min: 384868,
            max: 438095,
          },
          10000000: {
            min: 480461,
            max: 546908,
          },
          15000000: {
            min: 656480,
            max: 747270,
          },
          20000000: {
            min: 818801,
            max: 932040,
          },
          25000000: {
            min: 971476,
            max: 1105829,
          },
        },
        IV: {
          25000: {
            min: 5428,
            max: 6036,
          },
          35000: {
            min: 7042,
            max: 7831,
          },
          50000: {
            min: 9279,
            max: 10320,
          },
          75000: {
            min: 12697,
            max: 14121,
          },
          100000: {
            min: 15859,
            max: 17637,
          },
          150000: {
            min: 21693,
            max: 24126,
          },
          200000: {
            min: 27088,
            max: 30126,
          },
          300000: {
            min: 37031,
            max: 41185,
          },
          500000: {
            min: 54861,
            max: 61013,
          },
          750000: {
            min: 74863,
            max: 83258,
          },
          1000000: {
            min: 93254,
            max: 103712,
          },
          1500000: {
            min: 127452,
            max: 141746,
          },
          2000000: {
            min: 159011,
            max: 176844,
          },
          3000000: {
            min: 217001,
            max: 241338,
          },
          5000000: {
            min: 320345,
            max: 356272,
          },
          7500000: {
            min: 438095,
            max: 487227,
          },
          10000000: {
            min: 546908,
            max: 608244,
          },
          15000000: {
            min: 747270,
            max: 831076,
          },
          20000000: {
            min: 932040,
            max: 1036568,
          },
          25000000: {
            min: 1105829,
            max: 1229848,
          },
        },
        V: {
          25000: {
            min: 6036,
            max: 6696,
          },
          35000: {
            min: 7831,
            max: 8687,
          },
          50000: {
            min: 10320,
            max: 11447,
          },
          75000: {
            min: 14121,
            max: 15663,
          },
          100000: {
            min: 17637,
            max: 19564,
          },
          150000: {
            min: 24126,
            max: 26762,
          },
          200000: {
            min: 30126,
            max: 33417,
          },
          300000: {
            min: 41185,
            max: 45684,
          },
          500000: {
            min: 61013,
            max: 67679,
          },
          750000: {
            min: 83258,
            max: 92354,
          },
          1000000: {
            min: 103712,
            max: 115042,
          },
          1500000: {
            min: 141746,
            max: 157230,
          },
          2000000: {
            min: 176844,
            max: 196163,
          },
          3000000: {
            min: 241338,
            max: 267702,
          },
          5000000: {
            min: 356272,
            max: 395192,
          },
          7500000: {
            min: 487227,
            max: 540453,
          },
          10000000: {
            min: 608244,
            max: 674690,
          },
          15000000: {
            min: 831076,
            max: 921866,
          },
          20000000: {
            min: 1036568,
            max: 1149806,
          },
          25000000: {
            min: 1229848,
            max: 1364201,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '2',
        },
        {
          title: 'Vorplanung',
          maxPercent: '20',
        },
        {
          title: 'Entwurfsplanung',
          maxPercent: '25',
        },
        {
          title: 'Genehmigungsplanung',
          maxPercent: '5',
        },
        {
          title: 'Ausführungsplanung',
          maxPercent: '15',
        },
        {
          title: 'Vorbereitung der Vergabe',
          maxPercent: '13',
        },
        {
          title: 'Mitwirkung bei der Vergabe',
          maxPercent: '4',
        },
        {
          title: 'Bauoberleitung',
          maxPercent: '15',
        },
        {
          title: 'Objektbetreuung',
          maxPercent: '1',
        },
      ],
    },
    {
      label: '§ 48 Abs. 1 Verkehrsanlagen',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      shownCostGroups: ['200', '300', '400', '500'],
      disabledCostGroups: [
        '200',
        '500',
        'ausstattung',
        'nebenanlagen',
        'leitungen',
        'verkehr',
        'erdarbeiten',
        'ingenieur',
      ],
      additionalFields: [
        {
          label:
            'Ausstattungen, die der Zweckbestimmung der Verkehrsanlagen dienen nach §46 Abs. 1',
          key: 'ausstattung',
        },
        {
          label: 'Umlegen und Verlegen von Leitungen nach §46 Abs. 3 Nr. 2',
          key: 'leitungen',
        },
        {
          label:
            'Nebenanlagen von Anlagen des Straßen-, Schienen- und Flugverkehrs nach §46 Abs. 3 Nr. 3',
          key: 'nebenanlagen',
        },
        {
          label:
            'Verkehrsregelnde Maßnahmen während der Bauzeit nach §46 Abs. 3 Nr. 4',
          key: 'verkehr',
        },
        {
          label:
            'Kosten für Erdarbeiten einschließlich Felsarbeiten §46 Abs. 4 Nr. 1',
          key: 'erdarbeiten',
        },
        {
          label: 'Kosten für Ingenieurbauwerke §46 Abs. 4 Nr. 2',
          key: 'ingenieur',
        },
      ],
      creditableCostFunction: function creditableCostFunction(
        entries,
        additionalFields
      ) {
        const abs1 =
          (entries.find((el) => el.number == '300')?.costs ?? 0) +
          (additionalFields?.find((el) => el.key == 'ausstattung')?.costs ?? 0);

        const erdarbeiten = Math.min(
          additionalFields?.find((el) => el.key == 'erdarbeiten')?.costs ?? 0,
          abs1 * 0.4
        );

        const ingenieur =
          0.1 *
          (additionalFields?.find((el) => el.key == 'ingenieur')?.costs ?? 0);

        const costGroups = entries.reduce((acc, el) => {
          if (el.number != '400' && el.number != '300') {
            acc += el.costs ?? 0;
          }
          return acc;
        }, 0);

        const additionalsAndCostGroups =
          costGroups +
          additionalFields?.reduce((acc, el) => {
            if (
              el.key != 'ausstattung' &&
              el.key != 'erdarbeiten' &&
              el.key != 'ingenieur'
            ) {
              acc += el.costs ?? 0;
            }
            return acc;
          }, 0);

        const other = abs1 + erdarbeiten + ingenieur + additionalsAndCostGroups;

        const technicalCosts =
          entries.find((el) => el.number == '400')?.costs ?? 0;

        if (technicalCosts < 0.25 * other) {
          return other + technicalCosts;
        } else {
          return other + 0.25 * other + (technicalCosts - 0.25 * other) * 0.5;
        }
      },
      honorariumZone: {
        I: {
          25000: {
            min: 3882,
            max: 4624,
          },
          35000: {
            min: 4981,
            max: 5933,
          },
          50000: {
            min: 6487,
            max: 7727,
          },
          75000: {
            min: 8759,
            max: 10434,
          },
          100000: {
            min: 10839,
            max: 12911,
          },
          150000: {
            min: 14634,
            max: 17432,
          },
          200000: {
            min: 18106,
            max: 21567,
          },
          300000: {
            min: 24435,
            max: 29106,
          },
          500000: {
            min: 35622,
            max: 42433,
          },
          750000: {
            min: 48001,
            max: 57178,
          },
          1000000: {
            min: 59267,
            max: 70597,
          },
          1500000: {
            min: 80009,
            max: 95305,
          },
          2000000: {
            min: 98962,
            max: 117881,
          },
          3000000: {
            min: 133441,
            max: 158951,
          },
          5000000: {
            min: 194094,
            max: 231200,
          },
          7500000: {
            min: 262407,
            max: 312573,
          },
          10000000: {
            min: 324978,
            max: 387107,
          },
          15000000: {
            min: 439179,
            max: 523140,
          },
          20000000: {
            min: 543619,
            max: 647546,
          },
          25000000: {
            min: 641265,
            max: 763860,
          },
        },
        II: {
          25000: {
            min: 4624,
            max: 5366,
          },
          35000: {
            min: 5933,
            max: 6885,
          },
          50000: {
            min: 7727,
            max: 8967,
          },
          75000: {
            min: 10434,
            max: 12108,
          },
          100000: {
            min: 12911,
            max: 14983,
          },
          150000: {
            min: 17432,
            max: 20229,
          },
          200000: {
            min: 21567,
            max: 25029,
          },
          300000: {
            min: 29106,
            max: 33778,
          },
          500000: {
            min: 42433,
            max: 49243,
          },
          750000: {
            min: 57178,
            max: 66355,
          },
          1000000: {
            min: 70597,
            max: 81928,
          },
          1500000: {
            min: 95305,
            max: 110600,
          },
          2000000: {
            min: 117881,
            max: 136800,
          },
          3000000: {
            min: 158951,
            max: 184462,
          },
          5000000: {
            min: 231200,
            max: 268306,
          },
          7500000: {
            min: 312573,
            max: 362739,
          },
          10000000: {
            min: 387107,
            max: 449235,
          },
          15000000: {
            min: 523140,
            max: 607101,
          },
          20000000: {
            min: 647546,
            max: 751473,
          },
          25000000: {
            min: 763860,
            max: 886454,
          },
        },
        III: {
          25000: {
            min: 5366,
            max: 6108,
          },
          35000: {
            min: 6885,
            max: 7837,
          },
          50000: {
            min: 8967,
            max: 10207,
          },
          75000: {
            min: 12108,
            max: 13783,
          },
          100000: {
            min: 14983,
            max: 17056,
          },
          150000: {
            min: 20229,
            max: 23027,
          },
          200000: {
            min: 25029,
            max: 28490,
          },
          300000: {
            min: 33778,
            max: 38449,
          },
          500000: {
            min: 49243,
            max: 56053,
          },
          750000: {
            min: 66355,
            max: 75532,
          },
          1000000: {
            min: 81928,
            max: 93258,
          },
          1500000: {
            min: 110600,
            max: 125896,
          },
          2000000: {
            min: 136800,
            max: 155719,
          },
          3000000: {
            min: 184462,
            max: 209973,
          },
          5000000: {
            min: 268306,
            max: 305412,
          },
          7500000: {
            min: 362739,
            max: 412905,
          },
          10000000: {
            min: 449235,
            max: 511363,
          },
          15000000: {
            min: 607101,
            max: 691062,
          },
          20000000: {
            min: 751473,
            max: 855401,
          },
          25000000: {
            min: 886454,
            max: 1009049,
          },
        },
        IV: {
          25000: {
            min: 6108,
            max: 6793,
          },
          35000: {
            min: 7837,
            max: 8716,
          },
          50000: {
            min: 10207,
            max: 11352,
          },
          75000: {
            min: 13783,
            max: 15328,
          },
          100000: {
            min: 17056,
            max: 18968,
          },
          150000: {
            min: 23027,
            max: 25610,
          },
          200000: {
            min: 28490,
            max: 31685,
          },
          300000: {
            min: 38449,
            max: 42761,
          },
          500000: {
            min: 56053,
            max: 62339,
          },
          750000: {
            min: 75532,
            max: 84002,
          },
          1000000: {
            min: 93258,
            max: 103717,
          },
          1500000: {
            min: 125896,
            max: 140015,
          },
          2000000: {
            min: 155719,
            max: 173183,
          },
          3000000: {
            min: 209973,
            max: 233521,
          },
          5000000: {
            min: 305412,
            max: 339664,
          },
          7500000: {
            min: 412905,
            max: 459212,
          },
          10000000: {
            min: 511363,
            max: 568712,
          },
          15000000: {
            min: 691062,
            max: 768564,
          },
          20000000: {
            min: 855401,
            max: 951333,
          },
          25000000: {
            min: 1009049,
            max: 1122213,
          },
        },
        V: {
          25000: {
            min: 6793,
            max: 7535,
          },
          35000: {
            min: 8716,
            max: 9668,
          },
          50000: {
            min: 11352,
            max: 12592,
          },
          75000: {
            min: 15328,
            max: 17003,
          },
          100000: {
            min: 18968,
            max: 21041,
          },
          150000: {
            min: 25610,
            max: 28407,
          },
          200000: {
            min: 31685,
            max: 35147,
          },
          300000: {
            min: 42761,
            max: 47433,
          },
          500000: {
            min: 62339,
            max: 69149,
          },
          750000: {
            min: 84002,
            max: 93179,
          },
          1000000: {
            min: 103717,
            max: 115047,
          },
          1500000: {
            min: 140015,
            max: 155311,
          },
          2000000: {
            min: 173183,
            max: 192102,
          },
          3000000: {
            min: 233521,
            max: 259032,
          },
          5000000: {
            min: 339664,
            max: 376770,
          },
          7500000: {
            min: 459212,
            max: 509378,
          },
          10000000: {
            min: 568712,
            max: 630840,
          },
          15000000: {
            min: 768564,
            max: 852525,
          },
          20000000: {
            min: 951333,
            max: 1055260,
          },
          25000000: {
            min: 1122213,
            max: 1244808,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '2',
        },
        {
          title: 'Vorplanung',
          maxPercent: '20',
        },
        {
          title: 'Entwurfsplanung',
          maxPercent: '25',
        },
        {
          title: 'Genehmigungsplanung',
          maxPercent: '8',
        },
        {
          title: 'Ausführungsplanung',
          maxPercent: '15',
        },
        {
          title: 'Vorbereitung der Vergabe',
          maxPercent: '10',
        },
        {
          title: 'Mitwirkung bei der Vergabe',
          maxPercent: '4',
        },
        {
          title: 'Bauoberleitung',
          maxPercent: '15',
        },
        {
          title: 'Objektbetreuung',
          maxPercent: '1',
        },
      ],
    },
    {
      label: '§ 52 Abs. 1 Tragwerksplanung',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      shownCostGroups: [],
      disabledCostGroups: [],
      additionalFields: [
        {
          label:
            'Gebäuden und zugehörigen baulichen Anlagen - Baukonstruktionskosten nach §50 Abs. 1',
          key: 'gebBaukonst',
        },
        {
          label:
            'Gebäuden und zugehörigen baulichen Anlagen - Technischen Anlagen nach §50 Abs. 1',
          key: 'gebTechAnl',
        },
        {
          label: 'Ingenieurbauwerken - Baukonstruktionskosten nach §50 Abs. 3',
          key: 'ingBaukonst',
        },
        {
          label: 'Ingenieurbauwerken - Technischen Anlagen nach §50 Abs. 3',
          key: 'ingTechAnl',
        },
        {
          label:
            'Ingenieurbauwerken - Herstellkosten einschließlich der zugehörigen Kosten für Baustelleneinrichtungen von Traggerüsten nach §50 Abs. 4',
          key: 'ingTrag',
        },
      ],
      creditableCostFunction: function creditableCostFunction(
        entries,
        additionalFields
      ) {
        const gebBaukonst =
          0.55 *
          (additionalFields.find((el) => el.key == 'gebBaukonst')?.costs ?? 0);
        const gebTechAnl =
          0.1 *
          (additionalFields.find((el) => el.key == 'gebTechAnl')?.costs ?? 0);
        const ingBaukonst =
          0.9 *
          (additionalFields.find((el) => el.key == 'ingBaukonst')?.costs ?? 0);
        const ingTechAnl =
          0.15 *
          (additionalFields.find((el) => el.key == 'ingTechAnl')?.costs ?? 0);
        const ingTrag =
          additionalFields.find((el) => el.key == 'ingTrag')?.costs ?? 0;

        return gebBaukonst + gebTechAnl + ingBaukonst + ingTechAnl + ingTrag;
      },
      honorariumZone: {
        I: {
          10000: {
            min: 1461,
            max: 1624,
          },
          15000: {
            min: 2011,
            max: 2234,
          },
          25000: {
            min: 3006,
            max: 3340,
          },
          50000: {
            min: 5187,
            max: 5763,
          },
          75000: {
            min: 7135,
            max: 7928,
          },
          100000: {
            min: 8946,
            max: 9940,
          },
          150000: {
            min: 12303,
            max: 13670,
          },
          250000: {
            min: 18370,
            max: 20411,
          },
          350000: {
            min: 23909,
            max: 26565,
          },
          500000: {
            min: 31594,
            max: 35105,
          },
          750000: {
            min: 43463,
            max: 48293,
          },
          1000000: {
            min: 54495,
            max: 60550,
          },
          1250000: {
            min: 64940,
            max: 72155,
          },
          1500000: {
            min: 74938,
            max: 83265,
          },
          2000000: {
            min: 93923,
            max: 104358,
          },
          3000000: {
            min: 129059,
            max: 143398,
          },
          5000000: {
            min: 192384,
            max: 213760,
          },
          7500000: {
            min: 264487,
            max: 293874,
          },
          10000000: {
            min: 331398,
            max: 368220,
          },
          15000000: {
            min: 455117,
            max: 505686,
          },
        },
        II: {
          10000: {
            min: 1624,
            max: 2064,
          },
          15000: {
            min: 2234,
            max: 2841,
          },
          25000: {
            min: 3340,
            max: 4247,
          },
          50000: {
            min: 5763,
            max: 7327,
          },
          75000: {
            min: 7928,
            max: 10080,
          },
          100000: {
            min: 9940,
            max: 12639,
          },
          150000: {
            min: 13670,
            max: 17380,
          },
          250000: {
            min: 20411,
            max: 25951,
          },
          350000: {
            min: 26565,
            max: 33776,
          },
          500000: {
            min: 35105,
            max: 44633,
          },
          750000: {
            min: 48293,
            max: 61401,
          },
          1000000: {
            min: 60550,
            max: 76984,
          },
          1250000: {
            min: 72155,
            max: 91740,
          },
          1500000: {
            min: 83265,
            max: 105865,
          },
          2000000: {
            min: 104358,
            max: 132684,
          },
          3000000: {
            min: 143398,
            max: 182321,
          },
          5000000: {
            min: 213760,
            max: 271781,
          },
          7500000: {
            min: 293874,
            max: 373640,
          },
          10000000: {
            min: 368220,
            max: 468166,
          },
          15000000: {
            min: 505686,
            max: 642943,
          },
        },
        III: {
          10000: {
            min: 2064,
            max: 2575,
          },
          15000: {
            min: 2841,
            max: 3543,
          },
          25000: {
            min: 4247,
            max: 5296,
          },
          50000: {
            min: 7327,
            max: 9139,
          },
          75000: {
            min: 10080,
            max: 12572,
          },
          100000: {
            min: 12639,
            max: 15763,
          },
          150000: {
            min: 17380,
            max: 21677,
          },
          250000: {
            min: 25951,
            max: 32365,
          },
          350000: {
            min: 33776,
            max: 42125,
          },
          500000: {
            min: 44633,
            max: 55666,
          },
          750000: {
            min: 61401,
            max: 76578,
          },
          1000000: {
            min: 76984,
            max: 96014,
          },
          1250000: {
            min: 91740,
            max: 114418,
          },
          1500000: {
            min: 105865,
            max: 132034,
          },
          2000000: {
            min: 132684,
            max: 165483,
          },
          3000000: {
            min: 182321,
            max: 227389,
          },
          5000000: {
            min: 271781,
            max: 338962,
          },
          7500000: {
            min: 373640,
            max: 466001,
          },
          10000000: {
            min: 468166,
            max: 583892,
          },
          15000000: {
            min: 642943,
            max: 801873,
          },
        },
        IV: {
          10000: {
            min: 2575,
            max: 3015,
          },
          15000: {
            min: 3543,
            max: 4149,
          },
          25000: {
            min: 5296,
            max: 6203,
          },
          50000: {
            min: 9139,
            max: 10703,
          },
          75000: {
            min: 12572,
            max: 14724,
          },
          100000: {
            min: 15763,
            max: 18461,
          },
          150000: {
            min: 21677,
            max: 25387,
          },
          250000: {
            min: 32365,
            max: 37906,
          },
          350000: {
            min: 42125,
            max: 49335,
          },
          500000: {
            min: 55666,
            max: 65194,
          },
          750000: {
            min: 76578,
            max: 89686,
          },
          1000000: {
            min: 96014,
            max: 112449,
          },
          1250000: {
            min: 114418,
            max: 134003,
          },
          1500000: {
            min: 132034,
            max: 154635,
          },
          2000000: {
            min: 165483,
            max: 193808,
          },
          3000000: {
            min: 227389,
            max: 266311,
          },
          5000000: {
            min: 338962,
            max: 396983,
          },
          7500000: {
            min: 466001,
            max: 545767,
          },
          10000000: {
            min: 583892,
            max: 683838,
          },
          15000000: {
            min: 801873,
            max: 939131,
          },
        },
        V: {
          10000: {
            min: 3015,
            max: 3178,
          },
          15000: {
            min: 4149,
            max: 4373,
          },
          25000: {
            min: 6203,
            max: 6537,
          },
          50000: {
            min: 10703,
            max: 11279,
          },
          75000: {
            min: 14724,
            max: 15517,
          },
          100000: {
            min: 18461,
            max: 19455,
          },
          150000: {
            min: 25387,
            max: 26754,
          },
          250000: {
            min: 37906,
            max: 39947,
          },
          350000: {
            min: 49335,
            max: 51992,
          },
          500000: {
            min: 65194,
            max: 68705,
          },
          750000: {
            min: 89686,
            max: 94515,
          },
          1000000: {
            min: 112449,
            max: 118504,
          },
          1250000: {
            min: 134003,
            max: 141218,
          },
          1500000: {
            min: 154635,
            max: 162961,
          },
          2000000: {
            min: 193808,
            max: 204244,
          },
          3000000: {
            min: 266311,
            max: 280651,
          },
          5000000: {
            min: 396983,
            max: 418359,
          },
          7500000: {
            min: 545767,
            max: 575154,
          },
          10000000: {
            min: 683838,
            max: 720660,
          },
          15000000: {
            min: 939131,
            max: 989699,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '3',
        },
        {
          title: 'Vorplanung',
          maxPercent: '10',
        },
        {
          title: 'Entwurfsplanung',
          maxPercent: '15',
        },
        {
          title: 'Genehmigungsplanung',
          maxPercent: '30',
        },
        {
          title: 'Ausführungsplanung',
          maxPercent: '40',
        },
        {
          title: 'Vorbereitung der Vergabe',
          maxPercent: '2',
        },
      ],
    },
    {
      label: '§ 56 Abs. 1 Technischen Ausrüstung',
      unitLabel: 'Anrechenbare Kosten',
      unit: 'euro',
      shownCostGroups: ['400'],
      disabledCostGroups: [],
      additionalFields: [],
      creditableCostFunction: function creditableCostFunction(
        entries,
        additionalFields
      ) {
        const costGroups = entries.reduce((acc, el) => {
          acc += el.costs ?? 0;

          return acc;
        }, 0);

        const other =
          costGroups +
          additionalFields?.reduce((acc, el) => {
            acc += el.costs ?? 0;
            return acc;
          }, 0);

        return other;
      },
      honorariumZone: {
        I: {
          5000: {
            min: 2132,
            max: 2547,
          },
          10000: {
            min: 3689,
            max: 4408,
          },
          15000: {
            min: 5084,
            max: 6075,
          },
          25000: {
            min: 7615,
            max: 9098,
          },
          35000: {
            min: 9934,
            max: 11869,
          },
          50000: {
            min: 13165,
            max: 15729,
          },
          75000: {
            min: 18122,
            max: 21652,
          },
          100000: {
            min: 22723,
            max: 27150,
          },
          150000: {
            min: 31228,
            max: 37311,
          },
          250000: {
            min: 46640,
            max: 55726,
          },
          500000: {
            min: 80684,
            max: 96402,
          },
          750000: {
            min: 111105,
            max: 132749,
          },
          1000000: {
            min: 139347,
            max: 166493,
          },
          1250000: {
            min: 166043,
            max: 198389,
          },
          1500000: {
            min: 191545,
            max: 228859,
          },
          2000000: {
            min: 239792,
            max: 286504,
          },
          2500000: {
            min: 285649,
            max: 341295,
          },
          3000000: {
            min: 329420,
            max: 393593,
          },
          3500000: {
            min: 371491,
            max: 443859,
          },
          4000000: {
            min: 412126,
            max: 492410,
          },
        },
        II: {
          5000: {
            min: 2547,
            max: 2990,
          },
          10000: {
            min: 4408,
            max: 5174,
          },
          15000: {
            min: 6075,
            max: 7131,
          },
          25000: {
            min: 9098,
            max: 10681,
          },
          35000: {
            min: 11869,
            max: 13934,
          },
          50000: {
            min: 15729,
            max: 18465,
          },
          75000: {
            min: 21652,
            max: 25418,
          },
          100000: {
            min: 27150,
            max: 31872,
          },
          150000: {
            min: 37311,
            max: 43800,
          },
          250000: {
            min: 55726,
            max: 65418,
          },
          500000: {
            min: 96402,
            max: 113168,
          },
          750000: {
            min: 132749,
            max: 155836,
          },
          1000000: {
            min: 166493,
            max: 195448,
          },
          1250000: {
            min: 198389,
            max: 232891,
          },
          1500000: {
            min: 228859,
            max: 268660,
          },
          2000000: {
            min: 286504,
            max: 336331,
          },
          2500000: {
            min: 341295,
            max: 400650,
          },
          3000000: {
            min: 393593,
            max: 462044,
          },
          3500000: {
            min: 443859,
            max: 521052,
          },
          4000000: {
            min: 492410,
            max: 578046,
          },
        },
        III: {
          5000: {
            min: 2990,
            max: 3405,
          },
          10000: {
            min: 5174,
            max: 5893,
          },
          15000: {
            min: 7131,
            max: 8122,
          },
          25000: {
            min: 10681,
            max: 12164,
          },
          35000: {
            min: 13934,
            max: 15869,
          },
          50000: {
            min: 18465,
            max: 21029,
          },
          75000: {
            min: 25418,
            max: 28948,
          },
          100000: {
            min: 31872,
            max: 36299,
          },
          150000: {
            min: 43800,
            max: 49883,
          },
          250000: {
            min: 65418,
            max: 74504,
          },
          500000: {
            min: 113168,
            max: 128886,
          },
          750000: {
            min: 155836,
            max: 177480,
          },
          1000000: {
            min: 195448,
            max: 222594,
          },
          1250000: {
            min: 232891,
            max: 265237,
          },
          1500000: {
            min: 268660,
            max: 305974,
          },
          2000000: {
            min: 336331,
            max: 383044,
          },
          2500000: {
            min: 400650,
            max: 456296,
          },
          3000000: {
            min: 462044,
            max: 526217,
          },
          3500000: {
            min: 521052,
            max: 593420,
          },
          4000000: {
            min: 578046,
            max: 658331,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '2',
        },
        {
          title: 'Vorplanung',
          maxPercent: '9',
        },
        {
          title: 'Entwurfsplanung',
          maxPercent: '17',
        },
        {
          title: 'Genehmigungsplanung',
          maxPercent: '2',
        },
        {
          title: 'Ausführungsplanung',
          maxPercent: '22',
        },
        {
          title: 'Vorbereitung der Vergabe',
          maxPercent: '7',
        },
        {
          title: 'Mitwirkung bei der Vergabe',
          maxPercent: '5',
        },
        {
          title: 'Objektüberwachung – Bauüberwachung',
          maxPercent: '35',
        },
        {
          title: 'Objektbetreuung',
          maxPercent: '1',
        },
      ],
    },
    {
      label: 'Anlage 1, Ziff. 1.1 - Umweltverträglichkeitsstudie',
      unitLabel: 'Fläche in ha',
      unit: 'ha',
      honorariumZone: {
        I: {
          50: {
            min: 10176,
            max: 12862,
          },
          100: {
            min: 14972,
            max: 18923,
          },
          150: {
            min: 18942,
            max: 23940,
          },
          200: {
            min: 22454,
            max: 28380,
          },
          300: {
            min: 28644,
            max: 36203,
          },
          400: {
            min: 34117,
            max: 43120,
          },
          500: {
            min: 39110,
            max: 49431,
          },
          750: {
            min: 50211,
            max: 63461,
          },
          1000: {
            min: 60004,
            max: 75838,
          },
          1500: {
            min: 77182,
            max: 97550,
          },
          2000: {
            min: 92278,
            max: 116629,
          },
          2500: {
            min: 105963,
            max: 133925,
          },
          3000: {
            min: 118598,
            max: 149895,
          },
          4000: {
            min: 141533,
            max: 178883,
          },
          5000: {
            min: 162148,
            max: 204937,
          },
          6000: {
            min: 182186,
            max: 230263,
          },
          7000: {
            min: 201072,
            max: 254133,
          },
          8000: {
            min: 218466,
            max: 276117,
          },
          9000: {
            min: 234394,
            max: 296247,
          },
          10000: {
            min: 249492,
            max: 315330,
          },
        },
        II: {
          50: {
            min: 12862,
            max: 15406,
          },
          100: {
            min: 18923,
            max: 22666,
          },
          150: {
            min: 23940,
            max: 28676,
          },
          200: {
            min: 28380,
            max: 33994,
          },
          300: {
            min: 36203,
            max: 43364,
          },
          400: {
            min: 43120,
            max: 51649,
          },
          500: {
            min: 49431,
            max: 59209,
          },
          750: {
            min: 63461,
            max: 76014,
          },
          1000: {
            min: 75838,
            max: 90839,
          },
          1500: {
            min: 97550,
            max: 116846,
          },
          2000: {
            min: 116629,
            max: 139698,
          },
          2500: {
            min: 133925,
            max: 160416,
          },
          3000: {
            min: 149895,
            max: 179544,
          },
          4000: {
            min: 178883,
            max: 214266,
          },
          5000: {
            min: 204937,
            max: 245474,
          },
          6000: {
            min: 230263,
            max: 275810,
          },
          7000: {
            min: 254133,
            max: 304401,
          },
          8000: {
            min: 276117,
            max: 330734,
          },
          9000: {
            min: 296247,
            max: 354846,
          },
          10000: {
            min: 315330,
            max: 377704,
          },
        },
        III: {
          50: {
            min: 15406,
            max: 18091,
          },
          100: {
            min: 22666,
            max: 26617,
          },
          150: {
            min: 28676,
            max: 33674,
          },
          200: {
            min: 33994,
            max: 39919,
          },
          300: {
            min: 43364,
            max: 50923,
          },
          400: {
            min: 51649,
            max: 60653,
          },
          500: {
            min: 59209,
            max: 69530,
          },
          750: {
            min: 76014,
            max: 89264,
          },
          1000: {
            min: 90839,
            max: 106674,
          },
          1500: {
            min: 116846,
            max: 137213,
          },
          2000: {
            min: 139698,
            max: 164049,
          },
          2500: {
            min: 160416,
            max: 188378,
          },
          3000: {
            min: 179544,
            max: 210841,
          },
          4000: {
            min: 214266,
            max: 251615,
          },
          5000: {
            min: 245474,
            max: 288263,
          },
          6000: {
            min: 275810,
            max: 323887,
          },
          7000: {
            min: 304401,
            max: 357461,
          },
          8000: {
            min: 330734,
            max: 388384,
          },
          9000: {
            min: 354846,
            max: 416700,
          },
          10000: {
            min: 377704,
            max: 443542,
          },
        },
      },
      phases: [
        {
          title:
            'Klären der Aufgabenstellung und Ermitteln des Leistungsumfangs',
          maxPercent: '3',
        },
        {
          title: 'Grundlagenermittlung',
          maxPercent: '37',
        },
        {
          title: 'Vorläufige Fassung',
          maxPercent: '50',
        },
        {
          title: 'Abgestimmte Fassung',
          maxPercent: '10',
        },
      ],
    },
    {
      label: 'Anlage 1, Ziff. 1.2.3 - Wärmeschutz und Energiebilanzierung',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      honorariumZone: {
        I: {
          250000: {
            min: 1757,
            max: 2023,
          },
          275000: {
            min: 1789,
            max: 2061,
          },
          300000: {
            min: 1821,
            max: 2097,
          },
          350000: {
            min: 1883,
            max: 2168,
          },
          400000: {
            min: 1941,
            max: 2235,
          },
          500000: {
            min: 2049,
            max: 2359,
          },
          600000: {
            min: 2146,
            max: 2471,
          },
          750000: {
            min: 2273,
            max: 2617,
          },
          1000000: {
            min: 2440,
            max: 2809,
          },
          1250000: {
            min: 2748,
            max: 3164,
          },
          1500000: {
            min: 3050,
            max: 3512,
          },
          2000000: {
            min: 3639,
            max: 4190,
          },
          2500000: {
            min: 4213,
            max: 4851,
          },
          3500000: {
            min: 5329,
            max: 6136,
          },
          5000000: {
            min: 6944,
            max: 7996,
          },
          7500000: {
            min: 9532,
            max: 10977,
          },
          10000000: {
            min: 12033,
            max: 13856,
          },
          15000000: {
            min: 16856,
            max: 19410,
          },
          20000000: {
            min: 21516,
            max: 24776,
          },
          25000000: {
            min: 26056,
            max: 30004,
          },
        },
        II: {
          250000: {
            min: 2023,
            max: 2395,
          },
          275000: {
            min: 2061,
            max: 2440,
          },
          300000: {
            min: 2097,
            max: 2484,
          },
          350000: {
            min: 2168,
            max: 2567,
          },
          400000: {
            min: 2235,
            max: 2647,
          },
          500000: {
            min: 2359,
            max: 2793,
          },
          600000: {
            min: 2471,
            max: 2926,
          },
          750000: {
            min: 2617,
            max: 3099,
          },
          1000000: {
            min: 2809,
            max: 3327,
          },
          1250000: {
            min: 3164,
            max: 3747,
          },
          1500000: {
            min: 3512,
            max: 4159,
          },
          2000000: {
            min: 4190,
            max: 4962,
          },
          2500000: {
            min: 4851,
            max: 5745,
          },
          3500000: {
            min: 6136,
            max: 7266,
          },
          5000000: {
            min: 7996,
            max: 9469,
          },
          7500000: {
            min: 10977,
            max: 12999,
          },
          10000000: {
            min: 13856,
            max: 16408,
          },
          15000000: {
            min: 19410,
            max: 22986,
          },
          20000000: {
            min: 24776,
            max: 29339,
          },
          25000000: {
            min: 30004,
            max: 35531,
          },
        },
        III: {
          250000: {
            min: 2395,
            max: 2928,
          },
          275000: {
            min: 2440,
            max: 2982,
          },
          300000: {
            min: 2484,
            max: 3036,
          },
          350000: {
            min: 2567,
            max: 3138,
          },
          400000: {
            min: 2647,
            max: 3235,
          },
          500000: {
            min: 2793,
            max: 3414,
          },
          600000: {
            min: 2926,
            max: 3576,
          },
          750000: {
            min: 3099,
            max: 3788,
          },
          1000000: {
            min: 3327,
            max: 4066,
          },
          1250000: {
            min: 3747,
            max: 4579,
          },
          1500000: {
            min: 4159,
            max: 5083,
          },
          2000000: {
            min: 4962,
            max: 6065,
          },
          2500000: {
            min: 5745,
            max: 7022,
          },
          3500000: {
            min: 7266,
            max: 8881,
          },
          5000000: {
            min: 9469,
            max: 11573,
          },
          7500000: {
            min: 12999,
            max: 15887,
          },
          10000000: {
            min: 16408,
            max: 20055,
          },
          15000000: {
            min: 22986,
            max: 28094,
          },
          20000000: {
            min: 29339,
            max: 35859,
          },
          25000000: {
            min: 35531,
            max: 43427,
          },
        },
        IV: {
          250000: {
            min: 2928,
            max: 3300,
          },
          275000: {
            min: 2982,
            max: 3362,
          },
          300000: {
            min: 3036,
            max: 3422,
          },
          350000: {
            min: 3138,
            max: 3537,
          },
          400000: {
            min: 3235,
            max: 3646,
          },
          500000: {
            min: 3414,
            max: 3849,
          },
          600000: {
            min: 3576,
            max: 4031,
          },
          750000: {
            min: 3788,
            max: 4270,
          },
          1000000: {
            min: 4066,
            max: 4583,
          },
          1250000: {
            min: 4579,
            max: 5162,
          },
          1500000: {
            min: 5083,
            max: 5730,
          },
          2000000: {
            min: 6065,
            max: 6837,
          },
          2500000: {
            min: 7022,
            max: 7916,
          },
          3500000: {
            min: 8881,
            max: 10012,
          },
          5000000: {
            min: 11573,
            max: 13046,
          },
          7500000: {
            min: 15887,
            max: 17909,
          },
          10000000: {
            min: 20055,
            max: 22607,
          },
          15000000: {
            min: 28094,
            max: 31670,
          },
          20000000: {
            min: 35859,
            max: 40423,
          },
          25000000: {
            min: 43427,
            max: 48954,
          },
        },
        V: {
          250000: {
            min: 3300,
            max: 3566,
          },
          275000: {
            min: 3362,
            max: 3633,
          },
          300000: {
            min: 3422,
            max: 3698,
          },
          350000: {
            min: 3537,
            max: 3822,
          },
          400000: {
            min: 3646,
            max: 3941,
          },
          500000: {
            min: 3849,
            max: 4159,
          },
          600000: {
            min: 4031,
            max: 4356,
          },
          750000: {
            min: 4270,
            max: 4614,
          },
          1000000: {
            min: 4583,
            max: 4953,
          },
          1250000: {
            min: 5162,
            max: 5579,
          },
          1500000: {
            min: 5730,
            max: 6192,
          },
          2000000: {
            min: 6837,
            max: 7388,
          },
          2500000: {
            min: 7916,
            max: 8554,
          },
          3500000: {
            min: 10012,
            max: 10819,
          },
          5000000: {
            min: 13046,
            max: 14098,
          },
          7500000: {
            min: 17909,
            max: 19354,
          },
          10000000: {
            min: 22607,
            max: 24430,
          },
          15000000: {
            min: 31670,
            max: 34224,
          },
          20000000: {
            min: 40423,
            max: 43683,
          },
          25000000: {
            min: 48954,
            max: 52902,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '3',
        },
        {
          title: 'Mitwirken bei der Vorplanung',
          maxPercent: '20',
        },
        {
          title: 'Mitwirken bei der Entwurfsplanung',
          maxPercent: '40',
        },
        {
          title: 'Mitwirken bei der Genehmigungsplanung',
          maxPercent: '6',
        },
        {
          title: 'Mitwirken bei der Ausführungsplanung',
          maxPercent: '27',
        },
        {
          title: 'Mitwirken bei der Vorbereitung der Vergabe',
          maxPercent: '2',
        },
        {
          title: 'Mitwirken bei der Vergabe',
          maxPercent: '2',
        },
      ],
    },
    {
      label: 'Anlage 1, Ziff. 1.2.4 - Bauakustik',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      honorariumZone: {
        I: {
          250000: {
            min: 1729,
            max: 1985,
          },
          275000: {
            min: 1840,
            max: 2113,
          },
          300000: {
            min: 1948,
            max: 2237,
          },
          350000: {
            min: 2156,
            max: 2475,
          },
          400000: {
            min: 2353,
            max: 2701,
          },
          500000: {
            min: 2724,
            max: 3127,
          },
          600000: {
            min: 3069,
            max: 3524,
          },
          750000: {
            min: 3553,
            max: 4080,
          },
          1000000: {
            min: 4291,
            max: 4927,
          },
          1250000: {
            min: 4968,
            max: 5704,
          },
          1500000: {
            min: 5599,
            max: 6429,
          },
          2000000: {
            min: 6763,
            max: 7765,
          },
          2500000: {
            min: 7830,
            max: 8990,
          },
          3500000: {
            min: 9766,
            max: 11213,
          },
          5000000: {
            min: 12345,
            max: 14174,
          },
          7500000: {
            min: 16114,
            max: 18502,
          },
          10000000: {
            min: 19470,
            max: 22354,
          },
          15000000: {
            min: 25422,
            max: 29188,
          },
          20000000: {
            min: 30722,
            max: 35273,
          },
          25000000: {
            min: 35585,
            max: 40857,
          },
        },
        II: {
          250000: {
            min: 1985,
            max: 2284,
          },
          275000: {
            min: 2113,
            max: 2431,
          },
          300000: {
            min: 2237,
            max: 2574,
          },
          350000: {
            min: 2475,
            max: 2847,
          },
          400000: {
            min: 2701,
            max: 3108,
          },
          500000: {
            min: 3127,
            max: 3598,
          },
          600000: {
            min: 3524,
            max: 4055,
          },
          750000: {
            min: 4080,
            max: 4694,
          },
          1000000: {
            min: 4927,
            max: 5669,
          },
          1250000: {
            min: 5704,
            max: 6563,
          },
          1500000: {
            min: 6429,
            max: 7397,
          },
          2000000: {
            min: 7765,
            max: 8934,
          },
          2500000: {
            min: 8990,
            max: 10343,
          },
          3500000: {
            min: 11213,
            max: 12901,
          },
          5000000: {
            min: 14174,
            max: 16307,
          },
          7500000: {
            min: 18502,
            max: 21287,
          },
          10000000: {
            min: 22354,
            max: 25719,
          },
          15000000: {
            min: 29188,
            max: 33582,
          },
          20000000: {
            min: 35273,
            max: 40583,
          },
          25000000: {
            min: 40857,
            max: 47008,
          },
        },
        III: {
          250000: {
            min: 2284,
            max: 2625,
          },
          275000: {
            min: 2431,
            max: 2794,
          },
          300000: {
            min: 2574,
            max: 2959,
          },
          350000: {
            min: 2847,
            max: 3273,
          },
          400000: {
            min: 3108,
            max: 3573,
          },
          500000: {
            min: 3598,
            max: 4136,
          },
          600000: {
            min: 4055,
            max: 4661,
          },
          750000: {
            min: 4694,
            max: 5396,
          },
          1000000: {
            min: 5669,
            max: 6516,
          },
          1250000: {
            min: 6563,
            max: 7544,
          },
          1500000: {
            min: 7397,
            max: 8503,
          },
          2000000: {
            min: 8934,
            max: 10270,
          },
          2500000: {
            min: 10343,
            max: 11890,
          },
          3500000: {
            min: 12901,
            max: 14830,
          },
          5000000: {
            min: 16307,
            max: 18746,
          },
          7500000: {
            min: 21287,
            max: 24470,
          },
          10000000: {
            min: 25719,
            max: 29565,
          },
          15000000: {
            min: 33582,
            max: 38604,
          },
          20000000: {
            min: 40583,
            max: 46652,
          },
          25000000: {
            min: 47008,
            max: 54037,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '3',
        },
        {
          title: 'Mitwirken bei der Vorplanung',
          maxPercent: '20',
        },
        {
          title: 'Mitwirken bei der Entwurfsplanung',
          maxPercent: '40',
        },
        {
          title: 'Mitwirken bei der Genehmigungsplanung',
          maxPercent: '6',
        },
        {
          title: 'Mitwirken bei der Ausführungsplanung',
          maxPercent: '27',
        },
        {
          title: 'Mitwirken bei der Vorbereitung der Vergabe',
          maxPercent: '2',
        },
        {
          title: 'Mitwirken bei der Vergabe',
          maxPercent: '2',
        },
      ],
    },
    {
      label: 'Anlage 1, Ziff. 1.2.5 - Raumakustik',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      honorariumZone: {
        I: {
          50000: {
            min: 1714,
            max: 2226,
          },
          75000: {
            min: 1805,
            max: 2343,
          },
          100000: {
            min: 1892,
            max: 2457,
          },
          150000: {
            min: 2061,
            max: 2676,
          },
          200000: {
            min: 2225,
            max: 2888,
          },
          250000: {
            min: 2384,
            max: 3095,
          },
          300000: {
            min: 2540,
            max: 3297,
          },
          400000: {
            min: 2844,
            max: 3693,
          },
          500000: {
            min: 3141,
            max: 4078,
          },
          750000: {
            min: 3860,
            max: 5011,
          },
          1000000: {
            min: 4555,
            max: 5913,
          },
          1500000: {
            min: 5896,
            max: 7655,
          },
          2000000: {
            min: 7193,
            max: 9338,
          },
          2500000: {
            min: 8457,
            max: 10979,
          },
          3000000: {
            min: 9696,
            max: 12588,
          },
          4000000: {
            min: 12115,
            max: 15729,
          },
          5000000: {
            min: 14474,
            max: 18791,
          },
          6000000: {
            min: 16786,
            max: 21793,
          },
          7000000: {
            min: 19060,
            max: 24744,
          },
          7500000: {
            min: 20184,
            max: 26204,
          },
        },
        II: {
          50000: {
            min: 2226,
            max: 2737,
          },
          75000: {
            min: 2343,
            max: 2882,
          },
          100000: {
            min: 2457,
            max: 3021,
          },
          150000: {
            min: 2676,
            max: 3291,
          },
          200000: {
            min: 2888,
            max: 3551,
          },
          250000: {
            min: 3095,
            max: 3806,
          },
          300000: {
            min: 3297,
            max: 4055,
          },
          400000: {
            min: 3693,
            max: 4541,
          },
          500000: {
            min: 4078,
            max: 5015,
          },
          750000: {
            min: 5011,
            max: 6163,
          },
          1000000: {
            min: 5913,
            max: 7272,
          },
          1500000: {
            min: 7655,
            max: 9413,
          },
          2000000: {
            min: 9338,
            max: 11483,
          },
          2500000: {
            min: 10979,
            max: 13501,
          },
          3000000: {
            min: 12588,
            max: 15479,
          },
          4000000: {
            min: 15729,
            max: 19342,
          },
          5000000: {
            min: 18791,
            max: 23108,
          },
          6000000: {
            min: 21793,
            max: 26799,
          },
          7000000: {
            min: 24744,
            max: 30429,
          },
          7500000: {
            min: 26204,
            max: 32224,
          },
        },
        III: {
          50000: {
            min: 2737,
            max: 3279,
          },
          75000: {
            min: 2882,
            max: 3452,
          },
          100000: {
            min: 3021,
            max: 3619,
          },
          150000: {
            min: 3291,
            max: 3942,
          },
          200000: {
            min: 3551,
            max: 4254,
          },
          250000: {
            min: 3806,
            max: 4558,
          },
          300000: {
            min: 4055,
            max: 4857,
          },
          400000: {
            min: 4541,
            max: 5439,
          },
          500000: {
            min: 5015,
            max: 6007,
          },
          750000: {
            min: 6163,
            max: 7382,
          },
          1000000: {
            min: 7272,
            max: 8710,
          },
          1500000: {
            min: 9413,
            max: 11275,
          },
          2000000: {
            min: 11483,
            max: 13755,
          },
          2500000: {
            min: 13501,
            max: 16172,
          },
          3000000: {
            min: 15479,
            max: 18541,
          },
          4000000: {
            min: 19342,
            max: 23168,
          },
          5000000: {
            min: 23108,
            max: 27679,
          },
          6000000: {
            min: 26799,
            max: 32100,
          },
          7000000: {
            min: 30429,
            max: 36448,
          },
          7500000: {
            min: 32224,
            max: 38598,
          },
        },
        IV: {
          50000: {
            min: 3279,
            max: 3790,
          },
          75000: {
            min: 3452,
            max: 3990,
          },
          100000: {
            min: 3619,
            max: 4183,
          },
          150000: {
            min: 3942,
            max: 4557,
          },
          200000: {
            min: 4254,
            max: 4917,
          },
          250000: {
            min: 4558,
            max: 5269,
          },
          300000: {
            min: 4857,
            max: 5614,
          },
          400000: {
            min: 5439,
            max: 6287,
          },
          500000: {
            min: 6007,
            max: 6944,
          },
          750000: {
            min: 7382,
            max: 8533,
          },
          1000000: {
            min: 8710,
            max: 10069,
          },
          1500000: {
            min: 11275,
            max: 13034,
          },
          2000000: {
            min: 13755,
            max: 15900,
          },
          2500000: {
            min: 16172,
            max: 18694,
          },
          3000000: {
            min: 18541,
            max: 21433,
          },
          4000000: {
            min: 23168,
            max: 26781,
          },
          5000000: {
            min: 27679,
            max: 31996,
          },
          6000000: {
            min: 32100,
            max: 37107,
          },
          7000000: {
            min: 36448,
            max: 42133,
          },
          7500000: {
            min: 38598,
            max: 44618,
          },
        },
        V: {
          50000: {
            min: 3790,
            max: 4301,
          },
          75000: {
            min: 3990,
            max: 4528,
          },
          100000: {
            min: 4183,
            max: 4748,
          },
          150000: {
            min: 4557,
            max: 5171,
          },
          200000: {
            min: 4917,
            max: 5581,
          },
          250000: {
            min: 5269,
            max: 5980,
          },
          300000: {
            min: 5614,
            max: 6371,
          },
          400000: {
            min: 6287,
            max: 7136,
          },
          500000: {
            min: 6944,
            max: 7881,
          },
          750000: {
            min: 8533,
            max: 9684,
          },
          1000000: {
            min: 10069,
            max: 11427,
          },
          1500000: {
            min: 13034,
            max: 14792,
          },
          2000000: {
            min: 15900,
            max: 18045,
          },
          2500000: {
            min: 18694,
            max: 21217,
          },
          3000000: {
            min: 21433,
            max: 24325,
          },
          4000000: {
            min: 26781,
            max: 30395,
          },
          5000000: {
            min: 31996,
            max: 36313,
          },
          6000000: {
            min: 37107,
            max: 42113,
          },
          7000000: {
            min: 42133,
            max: 47817,
          },
          7500000: {
            min: 44618,
            max: 50638,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '3',
        },
        {
          title: 'Mitwirken bei der Vorplanung',
          maxPercent: '20',
        },
        {
          title: 'Mitwirken bei der Entwurfsplanung',
          maxPercent: '40',
        },
        {
          title: 'Mitwirken bei der Genehmigungsplanung',
          maxPercent: '6',
        },
        {
          title: 'Mitwirken bei der Ausführungsplanung',
          maxPercent: '27',
        },
        {
          title: 'Mitwirken bei der Vorbereitung der Vergabe',
          maxPercent: '2',
        },
        {
          title: 'Mitwirken bei der Vergabe',
          maxPercent: '2',
        },
      ],
    },
    {
      label: 'Anlage 1, Ziff. 1.3.4 - Geotechnik',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      honorariumZone: {
        I: {
          50000: {
            min: 789,
            max: 1222,
          },
          75000: {
            min: 951,
            max: 1472,
          },
          100000: {
            min: 1086,
            max: 1681,
          },
          125000: {
            min: 1204,
            max: 1863,
          },
          150000: {
            min: 1309,
            max: 2026,
          },
          200000: {
            min: 1494,
            max: 2312,
          },
          300000: {
            min: 1800,
            max: 2786,
          },
          400000: {
            min: 2054,
            max: 3179,
          },
          500000: {
            min: 2276,
            max: 3522,
          },
          750000: {
            min: 2740,
            max: 4241,
          },
          1000000: {
            min: 3125,
            max: 4836,
          },
          1500000: {
            min: 3765,
            max: 5827,
          },
          2000000: {
            min: 4297,
            max: 6650,
          },
          3000000: {
            min: 5175,
            max: 8009,
          },
          5000000: {
            min: 6535,
            max: 10114,
          },
          7500000: {
            min: 7878,
            max: 12192,
          },
          10000000: {
            min: 8994,
            max: 13919,
          },
          15000000: {
            min: 10839,
            max: 16775,
          },
          20000000: {
            min: 12373,
            max: 19148,
          },
          25000000: {
            min: 13708,
            max: 21215,
          },
        },
        II: {
          50000: {
            min: 1222,
            max: 1654,
          },
          75000: {
            min: 1472,
            max: 1993,
          },
          100000: {
            min: 1681,
            max: 2276,
          },
          125000: {
            min: 1863,
            max: 2522,
          },
          150000: {
            min: 2026,
            max: 2742,
          },
          200000: {
            min: 2312,
            max: 3130,
          },
          300000: {
            min: 2786,
            max: 3772,
          },
          400000: {
            min: 3179,
            max: 4304,
          },
          500000: {
            min: 3522,
            max: 4768,
          },
          750000: {
            min: 4241,
            max: 5741,
          },
          1000000: {
            min: 4836,
            max: 6548,
          },
          1500000: {
            min: 5827,
            max: 7889,
          },
          2000000: {
            min: 6650,
            max: 9003,
          },
          3000000: {
            min: 8009,
            max: 10842,
          },
          5000000: {
            min: 10114,
            max: 13693,
          },
          7500000: {
            min: 12192,
            max: 16506,
          },
          10000000: {
            min: 13919,
            max: 18844,
          },
          15000000: {
            min: 16775,
            max: 22711,
          },
          20000000: {
            min: 19148,
            max: 25923,
          },
          25000000: {
            min: 21215,
            max: 28722,
          },
        },
        III: {
          50000: {
            min: 1654,
            max: 2105,
          },
          75000: {
            min: 1993,
            max: 2537,
          },
          100000: {
            min: 2276,
            max: 2896,
          },
          125000: {
            min: 2522,
            max: 3210,
          },
          150000: {
            min: 2742,
            max: 3490,
          },
          200000: {
            min: 3130,
            max: 3984,
          },
          300000: {
            min: 3772,
            max: 4800,
          },
          400000: {
            min: 4304,
            max: 5478,
          },
          500000: {
            min: 4768,
            max: 6069,
          },
          750000: {
            min: 5741,
            max: 7307,
          },
          1000000: {
            min: 6548,
            max: 8334,
          },
          1500000: {
            min: 7889,
            max: 10041,
          },
          2000000: {
            min: 9003,
            max: 11459,
          },
          3000000: {
            min: 10842,
            max: 13799,
          },
          5000000: {
            min: 13693,
            max: 17428,
          },
          7500000: {
            min: 16506,
            max: 21007,
          },
          10000000: {
            min: 18844,
            max: 23983,
          },
          15000000: {
            min: 22711,
            max: 28905,
          },
          20000000: {
            min: 25923,
            max: 32993,
          },
          25000000: {
            min: 28722,
            max: 36556,
          },
        },
        IV: {
          50000: {
            min: 2105,
            max: 2537,
          },
          75000: {
            min: 2537,
            max: 3058,
          },
          100000: {
            min: 2896,
            max: 3491,
          },
          125000: {
            min: 3210,
            max: 3869,
          },
          150000: {
            min: 3490,
            max: 4207,
          },
          200000: {
            min: 3984,
            max: 4802,
          },
          300000: {
            min: 4800,
            max: 5786,
          },
          400000: {
            min: 5478,
            max: 6603,
          },
          500000: {
            min: 6069,
            max: 7315,
          },
          750000: {
            min: 7307,
            max: 8808,
          },
          1000000: {
            min: 8334,
            max: 10045,
          },
          1500000: {
            min: 10041,
            max: 12103,
          },
          2000000: {
            min: 11459,
            max: 13812,
          },
          3000000: {
            min: 13799,
            max: 16633,
          },
          5000000: {
            min: 17428,
            max: 21007,
          },
          7500000: {
            min: 21007,
            max: 25321,
          },
          10000000: {
            min: 23983,
            max: 28909,
          },
          15000000: {
            min: 28905,
            max: 34840,
          },
          20000000: {
            min: 32993,
            max: 39769,
          },
          25000000: {
            min: 36556,
            max: 44063,
          },
        },
        V: {
          50000: {
            min: 2537,
            max: 2970,
          },
          75000: {
            min: 3058,
            max: 3579,
          },
          100000: {
            min: 3491,
            max: 4086,
          },
          125000: {
            min: 3869,
            max: 4528,
          },
          150000: {
            min: 4207,
            max: 4924,
          },
          200000: {
            min: 4802,
            max: 5621,
          },
          300000: {
            min: 5786,
            max: 6772,
          },
          400000: {
            min: 6603,
            max: 7728,
          },
          500000: {
            min: 7315,
            max: 8561,
          },
          750000: {
            min: 8808,
            max: 10308,
          },
          1000000: {
            min: 10045,
            max: 11756,
          },
          1500000: {
            min: 12103,
            max: 14165,
          },
          2000000: {
            min: 13812,
            max: 16165,
          },
          3000000: {
            min: 16633,
            max: 19467,
          },
          5000000: {
            min: 21007,
            max: 24586,
          },
          7500000: {
            min: 25321,
            max: 29635,
          },
          10000000: {
            min: 28909,
            max: 33834,
          },
          15000000: {
            min: 34840,
            max: 40776,
          },
          20000000: {
            min: 39769,
            max: 46544,
          },
          25000000: {
            min: 44063,
            max: 51570,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung und Erkundungskonzept',
          maxPercent: '15',
        },
        {
          title: 'Beschreiben der Baugrund- und Grundwasserverhältnisse',
          maxPercent: '35',
        },
        {
          title:
            'Beurteilung der Baugrund- und Grundwasserverhältnisse, Empfehlungen, Hinweise, Angaben zur Bemessung der Gründung',
          maxPercent: '50',
        },
      ],
    },
    {
      label: 'Anlage 1, Ziff. 1.4.8. Abs. 1 - Planungsbegleitende Vermessung',
      unitLabel: 'Verrechnungseinheiten',
      unit: 'VE',
      honorariumZone: {
        I: {
          6: {
            min: 658,
            max: 777,
          },
          20: {
            min: 953,
            max: 1123,
          },
          50: {
            min: 1480,
            max: 1740,
          },
          103: {
            min: 2225,
            max: 2616,
          },
          188: {
            min: 3325,
            max: 3826,
          },
          278: {
            min: 4320,
            max: 4931,
          },
          359: {
            min: 5156,
            max: 5826,
          },
          435: {
            min: 5881,
            max: 6656,
          },
          506: {
            min: 6547,
            max: 7383,
          },
          659: {
            min: 7867,
            max: 8859,
          },
          822: {
            min: 9187,
            max: 10299,
          },
          1105: {
            min: 11332,
            max: 12667,
          },
          1400: {
            min: 13525,
            max: 14977,
          },
          2033: {
            min: 17714,
            max: 19597,
          },
          2713: {
            min: 21894,
            max: 24217,
          },
          3430: {
            min: 26074,
            max: 28837,
          },
          4949: {
            min: 34434,
            max: 38077,
          },
          7385: {
            min: 46974,
            max: 51937,
          },
          11726: {
            min: 67874,
            max: 75037,
          },
        },
        II: {
          6: {
            min: 777,
            max: 914,
          },
          20: {
            min: 1123,
            max: 1306,
          },
          50: {
            min: 1740,
            max: 2000,
          },
          103: {
            min: 2616,
            max: 3007,
          },
          188: {
            min: 3826,
            max: 4327,
          },
          278: {
            min: 4931,
            max: 5542,
          },
          359: {
            min: 5826,
            max: 6547,
          },
          435: {
            min: 6656,
            max: 7437,
          },
          506: {
            min: 7383,
            max: 8219,
          },
          659: {
            min: 8859,
            max: 9815,
          },
          822: {
            min: 10299,
            max: 11413,
          },
          1105: {
            min: 12667,
            max: 14002,
          },
          1400: {
            min: 14977,
            max: 16532,
          },
          2033: {
            min: 19597,
            max: 21592,
          },
          2713: {
            min: 24217,
            max: 26652,
          },
          3430: {
            min: 28837,
            max: 31712,
          },
          4949: {
            min: 38077,
            max: 41832,
          },
          7385: {
            min: 51937,
            max: 57012,
          },
          11726: {
            min: 75037,
            max: 82312,
          },
        },
        III: {
          6: {
            min: 914,
            max: 1051,
          },
          20: {
            min: 1306,
            max: 1489,
          },
          50: {
            min: 2000,
            max: 2260,
          },
          103: {
            min: 3007,
            max: 3399,
          },
          188: {
            min: 4327,
            max: 4829,
          },
          278: {
            min: 5542,
            max: 6153,
          },
          359: {
            min: 6547,
            max: 7217,
          },
          435: {
            min: 7437,
            max: 8212,
          },
          506: {
            min: 8219,
            max: 9055,
          },
          659: {
            min: 9815,
            max: 10809,
          },
          822: {
            min: 11413,
            max: 12513,
          },
          1105: {
            min: 14002,
            max: 15336,
          },
          1400: {
            min: 16532,
            max: 18086,
          },
          2033: {
            min: 21592,
            max: 23586,
          },
          2713: {
            min: 26652,
            max: 29086,
          },
          3430: {
            min: 31712,
            max: 34586,
          },
          4949: {
            min: 41832,
            max: 45586,
          },
          7385: {
            min: 57012,
            max: 62086,
          },
          11726: {
            min: 82312,
            max: 89586,
          },
        },
        IV: {
          6: {
            min: 1051,
            max: 1170,
          },
          20: {
            min: 1489,
            max: 1659,
          },
          50: {
            min: 2260,
            max: 2520,
          },
          103: {
            min: 3399,
            max: 3790,
          },
          188: {
            min: 4829,
            max: 5330,
          },
          278: {
            min: 6153,
            max: 6765,
          },
          359: {
            min: 7217,
            max: 7939,
          },
          435: {
            min: 8212,
            max: 8994,
          },
          506: {
            min: 9055,
            max: 9892,
          },
          659: {
            min: 10809,
            max: 11765,
          },
          822: {
            min: 12513,
            max: 13625,
          },
          1105: {
            min: 15336,
            max: 16672,
          },
          1400: {
            min: 18086,
            max: 19642,
          },
          2033: {
            min: 23586,
            max: 25582,
          },
          2713: {
            min: 29086,
            max: 31522,
          },
          3430: {
            min: 34586,
            max: 37462,
          },
          4949: {
            min: 45586,
            max: 49342,
          },
          7385: {
            min: 62086,
            max: 67162,
          },
          11726: {
            min: 89586,
            max: 96862,
          },
        },
        V: {
          6: {
            min: 1170,
            max: 1289,
          },
          20: {
            min: 1659,
            max: 1828,
          },
          50: {
            min: 2520,
            max: 2780,
          },
          103: {
            min: 3790,
            max: 4182,
          },
          188: {
            min: 5330,
            max: 5831,
          },
          278: {
            min: 6765,
            max: 7376,
          },
          359: {
            min: 7939,
            max: 8609,
          },
          435: {
            min: 8994,
            max: 9768,
          },
          506: {
            min: 9892,
            max: 10728,
          },
          659: {
            min: 11765,
            max: 12757,
          },
          822: {
            min: 13625,
            max: 14737,
          },
          1105: {
            min: 16672,
            max: 18006,
          },
          1400: {
            min: 19642,
            max: 21196,
          },
          2033: {
            min: 25582,
            max: 27576,
          },
          2713: {
            min: 31522,
            max: 33956,
          },
          3430: {
            min: 37462,
            max: 40336,
          },
          4949: {
            min: 49342,
            max: 53096,
          },
          7385: {
            min: 67162,
            max: 72236,
          },
          11726: {
            min: 96862,
            max: 104136,
          },
        },
      },
      phases: [
        {
          title: 'Grundlagenermittlung',
          maxPercent: '5',
        },
        {
          title: 'Geodätischer Raumbezug',
          maxPercent: '20',
        },
        {
          title: 'Vermessungstechnische Grundlagen',
          maxPercent: '65',
        },
        {
          title: 'Digitales Geländemodell',
          maxPercent: '10',
        },
      ],
    },
    {
      label: 'Anlage 1, Ziff. 1.4.8. Abs. 2 - Bauvermessung',
      unitLabel: 'Anrechenbare Kosten in Euro',
      unit: 'euro',
      honorariumZone: {
        I: {
          50000: {
            min: 4282,
            max: 4782,
          },
          75000: {
            min: 4648,
            max: 5191,
          },
          100000: {
            min: 5002,
            max: 5586,
          },
          150000: {
            min: 5684,
            max: 6349,
          },
          200000: {
            min: 6344,
            max: 7086,
          },
          250000: {
            min: 6987,
            max: 7804,
          },
          300000: {
            min: 7618,
            max: 8508,
          },
          400000: {
            min: 8848,
            max: 9883,
          },
          500000: {
            min: 10048,
            max: 11222,
          },
          600000: {
            min: 11223,
            max: 12535,
          },
          750000: {
            min: 12950,
            max: 14464,
          },
          1000000: {
            min: 15754,
            max: 17596,
          },
          1500000: {
            min: 21165,
            max: 23639,
          },
          2000000: {
            min: 26393,
            max: 29478,
          },
          2500000: {
            min: 31488,
            max: 35168,
          },
          3000000: {
            min: 36480,
            max: 40744,
          },
          4000000: {
            min: 46224,
            max: 51626,
          },
          5000000: {
            min: 55720,
            max: 62232,
          },
          7500000: {
            min: 78690,
            max: 87888,
          },
          10000000: {
            min: 100876,
            max: 112667,
          },
        },
        II: {
          50000: {
            min: 4782,
            max: 5283,
          },
          75000: {
            min: 5191,
            max: 5734,
          },
          100000: {
            min: 5586,
            max: 6171,
          },
          150000: {
            min: 6349,
            max: 7013,
          },
          200000: {
            min: 7086,
            max: 7827,
          },
          250000: {
            min: 7804,
            max: 8621,
          },
          300000: {
            min: 8508,
            max: 9399,
          },
          400000: {
            min: 9883,
            max: 10917,
          },
          500000: {
            min: 11222,
            max: 12397,
          },
          600000: {
            min: 12535,
            max: 13847,
          },
          750000: {
            min: 14464,
            max: 15978,
          },
          1000000: {
            min: 17596,
            max: 19437,
          },
          1500000: {
            min: 23639,
            max: 26113,
          },
          2000000: {
            min: 29478,
            max: 32563,
          },
          2500000: {
            min: 35168,
            max: 38849,
          },
          3000000: {
            min: 40744,
            max: 45008,
          },
          4000000: {
            min: 51626,
            max: 57029,
          },
          5000000: {
            min: 62232,
            max: 68745,
          },
          7500000: {
            min: 87888,
            max: 97085,
          },
          10000000: {
            min: 112667,
            max: 124458,
          },
        },
        III: {
          50000: {
            min: 5283,
            max: 5839,
          },
          75000: {
            min: 5734,
            max: 6338,
          },
          100000: {
            min: 6171,
            max: 6820,
          },
          150000: {
            min: 7013,
            max: 7751,
          },
          200000: {
            min: 7827,
            max: 8651,
          },
          250000: {
            min: 8621,
            max: 9528,
          },
          300000: {
            min: 9399,
            max: 10388,
          },
          400000: {
            min: 10917,
            max: 12066,
          },
          500000: {
            min: 12397,
            max: 13702,
          },
          600000: {
            min: 13847,
            max: 15304,
          },
          750000: {
            min: 15978,
            max: 17659,
          },
          1000000: {
            min: 19437,
            max: 21483,
          },
          1500000: {
            min: 26113,
            max: 28862,
          },
          2000000: {
            min: 32563,
            max: 35990,
          },
          2500000: {
            min: 38849,
            max: 42938,
          },
          3000000: {
            min: 45008,
            max: 49745,
          },
          4000000: {
            min: 57029,
            max: 63032,
          },
          5000000: {
            min: 68745,
            max: 75981,
          },
          7500000: {
            min: 97085,
            max: 107305,
          },
          10000000: {
            min: 124458,
            max: 137559,
          },
        },
        IV: {
          50000: {
            min: 5839,
            max: 6339,
          },
          75000: {
            min: 6338,
            max: 6881,
          },
          100000: {
            min: 6820,
            max: 7405,
          },
          150000: {
            min: 7751,
            max: 8416,
          },
          200000: {
            min: 8651,
            max: 9393,
          },
          250000: {
            min: 9528,
            max: 10345,
          },
          300000: {
            min: 10388,
            max: 11278,
          },
          400000: {
            min: 12066,
            max: 13100,
          },
          500000: {
            min: 13702,
            max: 14876,
          },
          600000: {
            min: 15304,
            max: 16616,
          },
          750000: {
            min: 17659,
            max: 19173,
          },
          1000000: {
            min: 21483,
            max: 23325,
          },
          1500000: {
            min: 28862,
            max: 31336,
          },
          2000000: {
            min: 35990,
            max: 39075,
          },
          2500000: {
            min: 42938,
            max: 46619,
          },
          3000000: {
            min: 49745,
            max: 54009,
          },
          4000000: {
            min: 63032,
            max: 68435,
          },
          5000000: {
            min: 75981,
            max: 82494,
          },
          7500000: {
            min: 107305,
            max: 116502,
          },
          10000000: {
            min: 137559,
            max: 149350,
          },
        },
        V: {
          50000: {
            min: 6339,
            max: 6840,
          },
          75000: {
            min: 6881,
            max: 7424,
          },
          100000: {
            min: 7405,
            max: 7989,
          },
          150000: {
            min: 8416,
            max: 9080,
          },
          200000: {
            min: 9393,
            max: 10134,
          },
          250000: {
            min: 10345,
            max: 11162,
          },
          300000: {
            min: 11278,
            max: 12169,
          },
          400000: {
            min: 13100,
            max: 14134,
          },
          500000: {
            min: 14876,
            max: 16051,
          },
          600000: {
            min: 16616,
            max: 17928,
          },
          750000: {
            min: 19173,
            max: 20687,
          },
          1000000: {
            min: 23325,
            max: 25166,
          },
          1500000: {
            min: 31336,
            max: 33810,
          },
          2000000: {
            min: 39075,
            max: 42160,
          },
          2500000: {
            min: 46619,
            max: 50299,
          },
          3000000: {
            min: 54009,
            max: 58273,
          },
          4000000: {
            min: 68435,
            max: 73838,
          },
          5000000: {
            min: 82494,
            max: 89007,
          },
          7500000: {
            min: 116502,
            max: 125700,
          },
          10000000: {
            min: 149350,
            max: 161140,
          },
        },
      },
      phases: [
        {
          title: 'Baugeometrische Beratung',
          maxPercent: '2',
        },
        {
          title: 'Absteckungsunterlagen',
          maxPercent: '5',
        },
        {
          title: 'Bauvorbereitende Vermessung',
          maxPercent: '16',
        },
        {
          title: 'Bauausführungsvermessung',
          maxPercent: '62',
        },
        {
          title: 'Vermessungstechnische Überwachung der Bauausführung',
          maxPercent: '15',
        },
      ],
    },
  ],
};
